import React from 'react'
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import {
  ThemeProvider, createTheme, Box, Grid, Card, CardContent, Typography,
  Avatar, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Select, MenuItem, Chip, IconButton, Tooltip, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow,
  LinearProgress, Badge, FormControl, Tab, Tabs, Paper,
  Snackbar, Alert, Stepper, Step, StepLabel
} from '@mui/material';
// import {
//   Dashboard as DashboardIcon,
//   People as PeopleIcon,
//   Pending as PendingIcon,
//   CheckCircle as CheckCircleIcon,
//   Add as AddIcon,
//   Schedule as ScheduleIcon,
//   Build as BuildIcon,
//   AttachMoney as AttachMoneyIcon,
//   Refresh as RefreshIcon,
//   MoreVert as MoreVertIcon,
//   TrendingUp as TrendingUpIcon,
//   TrendingDown as TrendingDownIcon,
//   Warning as WarningIcon,
//   Info as InfoIcon,
//   Delete as DeleteIcon,
//   Edit as EditIcon
// } from '@mui/icons-material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as ReTooltip,
  Legend, ResponsiveContainer, PieChart, Pie, Cell, LineChart,
  Line, AreaChart, Area, ComposedChart, RadarChart, Radar,
  PolarGrid, PolarAngleAxis, PolarRadiusAxis,
  LabelList
} from 'recharts';


// import {
//   BarChart, Bar, PieChart, Pie, Cell, Tooltip, Legend, XAxis, YAxis, CartesianGrid, LineChart, Line, ResponsiveContainer, LabelList
// } from 'recharts';


import { formattedDateLong } from "../../components/Date.jsx";
import { BASE_URL } from '../../config/axios';
import { formatCurrencyIndian, formatRoundoff, formatRoundoffCrores, handleErrorToast, ViewLetterModal } from '../../components/CustomFunctions';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { ProgressBar } from 'react-bootstrap';
import { EmployeebyTypeModel, EmployeeDesignationWiseModel, LetterbyStatusModel, ProjectByOurRoleModel, ProjectByWorkTypeModel, VacantEmployeebyTypeModel, DashboardLetterTatTypeModel } from '../../components/Dashborad/DashboardModels';
import { formatDate } from '../../components/Date.jsx'
import { AssociatedLetters } from '../../components/SiteManagement/ProjectDetailsCrudButtons.jsx';

const DashboardChart = () => {
  const [letterData, setLetterData] = useState(null);

  const getLetterDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/letter-admin-wise/`);
      setLetterData(response.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  useEffect(() => {
    getLetterDetails();
  }, []);

  if (!letterData) {
    return <div>Loading...</div>;
  }

  // Updated colors for "Letters by Status"
  const statusColors = {
    "pending": "#F97066", // Orange
    "close": "#B692F6",  // Teal
    "informative": "#53B1FD", // Deep Orange
    "complete": "#32D583", // Green
    "Partially Complete": "#FFEB3B", // Yellow
    "Overdue": "#E57373", // Light Red
    "in-progress": "#FDB022", // Light Blue
    "partially-close": ""
  };
  // Generate status data with colors
  const statusData = Object.keys(letterData.total_by_status).map(status => ({
    name: status,
    count: letterData.total_by_status[status],
    fill: statusColors[status] || "#BDBDBD" // Default Grey color for any undefined status
  }));

  const typeColors = [
    '#64C7FF', // Lighter Light Blue
    '#CE72DF', // Lighter Purple
    '#FF8F66', // Lighter Deep Orange
    '#8CE5A3', // Lighter Green
    '#FFD95B', // Lighter Amber
    '#66E6F1', // Lighter Cyan
    '#F88282', // Lighter Red
    '#BCAAA4', // Lighter Brown
    '#A992EA', // Lighter Indigo
    '#FFF176', // Lighter Light Yellow
  ];

  const typeColor = {
    "cos": "#F97066", // Orange
    "eot": "#B692F6",  // Teal
    "informative": "#53B1FD", // Deep Orange
    "billing": "#32D583", // Green
    "design": "#FDB022", // Yellow
    "null": "#98A2B3", // Light Red

  }

  const typeData = Object.keys(letterData.total_by_type).map((type, index) => ({
    name: type,
    count: letterData.total_by_type[type],
    fill: typeColor[type] || "#BDBDBD"
  }));

  // Data for the line chart
  const lineChartData = Object.entries(letterData.pending_by_concern_person).map(([person, count]) => ({
    name: person, // Person's name as the x-axis label
    count,        // Number of pending letters as the y-axis value
  }));



  const generateRandomData = () => {

    return Array.from({ length: 50 }, (_, index) => {
      const projectName = `Railway Tunnel Site Project ${index + 1}`;
      const prCode = `PR${index + 1}`;
      const actualSalary = Math.floor(Math.random() * 10000) + 5000; // Random actual salary between 5000 and 15000
      const boqSalary = Math.floor(Math.random() * 10000) + 5000; // Random BOQ salary between 5000 and 15000

      let profit = 0;
      let loss = 0;

      if (boqSalary > actualSalary) {
        profit = ((actualSalary / boqSalary) * 100).toFixed(2);
      } else if (actualSalary > boqSalary) {
        loss = ((boqSalary / actualSalary) * 100).toFixed(2);
      }
      return {
        projectName,
        prCode,
        actualSalary,
        boqSalary,
        profit,
        loss
      };
    });

  };

  return (
    <div className="chart-container table-css-white-background">
      <h3 className="chart-title">Letter Statistics (This Month)</h3>
      <div className="statistics-list">
        <li style={{ backgroundColor: "#32D583" }}>Received: {letterData.total_received}</li>
        <li style={{ backgroundColor: "#B692F6" }}>Closed: {letterData.total_closed}</li>
        <li style={{ backgroundColor: "#F97066" }}>Pending: {letterData.total_pending}</li>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {/* Bar Chart for Letters by Status */}
        <div className="chart-container" style={{ width: "35vw" }}>
          <h3 className="chart-title">Letters by Status</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={statusData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="count" barSize={50}>
                {statusData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Pie Chart for Letters by Type */}
        <div className="chart-container" style={{ width: "25vw" }}>
          <h3 className="chart-title">Letters by Type</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                dataKey="count"
                isAnimationActive={false}
                data={typeData}
                cx="50%"
                cy="50%"
                outerRadius={90}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {typeData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Line Chart for Pending Letters by Concern Person */}
        <div className="chart-container" style={{ width: "40vw" }}>
          <h3 className="chart-title">Pending Letters by Concern Person</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={lineChartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="count" stroke="#42A5F5" activeDot={{ r: 8 }} /> {/* Light Blue */}
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};




const BillingStatisticsChart = () => {
  const [billingData, setBillingData] = useState(null);

  const getBillingDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/billing-admin-wise/`);
      setBillingData(response.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  useEffect(() => {
    getBillingDetails();
  }, []);

  if (!billingData) {
    return <div>Loading...</div>;
  }

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AA00FF', '#FF0000'];

  const billTypeData = Object.keys(billingData.bill_type_statistics).map((type, index) => ({
    name: type.toUpperCase(),
    count: billingData.bill_type_statistics[type].count,
    totalSubmitted: parseFloat(billingData.bill_type_statistics[type].total_submitted_amount),
    totalRecommended: parseFloat(billingData.bill_type_statistics[type].total_recommended_amount),
  }));

  const pieData = [
    { name: 'Total Submitted', value: parseFloat(billingData.total_submitted_amount) },
    { name: 'Total Recommended', value: parseFloat(billingData.total_recommended_amount) },
  ];

  return (
    <div className="chart-container ">http://localhost:3000/admin/wfm
      <h3 className="chart-title">Billing Statistics Dashboard</h3>
      <div className='flex-row justify-evenly'>
        <div className="chart-container  width-40vw">
          <h3 className="chart-title">Total Submitted vs Recommended Amount</h3>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={120}
                fill="#8884d8"
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="chart-container">
          <h3 className="chart-title">Bill Count and Amount by Type</h3>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={billTypeData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
              <YAxis yAxisId="right" orientation="right" stroke="#82ca9d" />
              <Tooltip />
              <Legend />
              <Bar yAxisId="left" dataKey="count" fill="#8884d8" name="Bill Count" />
              <Bar yAxisId="right" dataKey="totalSubmitted" fill="#00C49F" name="Total Submitted Amount" />
              <Bar yAxisId="right" dataKey="totalRecommended" fill="#FFBB28" name="Total Recommended Amount" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="chart-container">
        <h3 className="chart-title">Average Submitted vs Recommended Amount</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={[{ name: 'Average', submitted: parseFloat(billingData.average_submitted_amount), recommended: parseFloat(billingData.average_recommended_amount) }]} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="submitted" stroke="#8884d8" name="Average Submitted Amount" />
            <Line type="monotone" dataKey="recommended" stroke="#82ca9d" name="Average Recommended Amount" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};






const ProjectStatusChart = () => {
  const [statusData, setStatusData] = useState([]);

  const getStatusCount = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/project-status-stats/`);
      const rawData = response.data;

      const statusOrder = [
        "Yet to Bid",
        "Yet to Award",
        "Yet to Sign Agreement",
        "Yet to Commence",
        "In Progress",
        "Completed",
        "In Progress including O&M",
        "Yet to Complete including O&M"
      ];

      const formattedData = Object.entries(rawData)
        .filter(([key]) => key && key !== "null") // Remove invalid keys
        .map(([status, count]) => ({
          status,
          count,
        }))
        .sort((a, b) => statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)); // Sort by order

      setStatusData(formattedData);
    } catch (error) {
      console.error("Failed to fetch project status count:", error);
    }
  };

  useEffect(() => {
    getStatusCount();
  }, []);

  // Short names and corresponding colors
  const statusShortNames = {
    "Yet to Bid": "To Bid",
    "Yet to Award": "To Award",
    "Yet to Sign Agreement": "To Sign",
    "Yet to Commence": "To Start",
    "In Progress": "Ongoing",
    "Completed": "Completed",
    "In Progress including O&M": "Prog_O&M",
    "Yet to Complete including O&M": "Comp_O&M",
  };

  const statusColors = {
    "To Bid": "#FFCCBC",
    "To Award": "#E1BEE7",
    "To Sign": "#C8E6C9",
    "To Start": "#FFEBEE",
    "Ongoing": "#64B5F6",
    "Completed": "#FFD54F",
    "Prog_O": "#64B5F6",
    "Comp_O": "#FFD54F",
  };

  // Custom Tick Component for Wrapping Short Names
  const CustomTick = ({ x, y, payload }) => {
    const shortName = statusShortNames[payload.value] || payload.value; // Get short name or fallback to original status name
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={10} textAnchor="middle" fill="#666" fontSize={10}>
          {shortName}
        </text>
      </g>
    );
  };

  return (
    <div className="invoice-cont  width-43vw  cont-col cards-shadow2 bgwhite transaction-cont box-shadow" style={{ margin: "10px" }}>
      <h2 className="dashboard-card-heading-blue font-weight500 transition " style={{ padding: "0px 25px" }}>Project Status</h2>
      <div className="flex-row justify-center">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={statusData} barCategoryGap="10%">
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="status"
              interval={0}
              tick={<CustomTick />}
              height={50} // Adjusted for short names
            />
            <YAxis tick={{ fontSize: 12 }} />
            <Bar dataKey="count" barSize={20} radius={[10, 10, 0, 0]}>
              <LabelList
                dataKey="count"
                position="top"
                style={{ fill: "#000", fontWeight: "bold", fontSize: "14px" }}
              />
              {statusData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={statusColors[statusShortNames[entry.status]] || "#607D8B"}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};




const VacantPositionsDashboard = () => {
  const [vacantData, setVacantData] = useState(null);

  const getVacantPositionsData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/employee-admin-wise/`);
      setVacantData(response.data);
    } catch (err) {
      console.error('Failed to fetch vacant positions data:', err);
    }
  };

  useEffect(() => {
    getVacantPositionsData();
  }, []);

  if (!vacantData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="dashboard-container">
      <h3 className="dashboard-title">Vacant Positions Status</h3>

      {['key_professionals', 'sub_professionals', 'support_staff'].map((type) => (
        <div key={type} className="vacant-positions-section">
          <h4 className="section-title">{type.replace('_', ' ').toUpperCase()}</h4>
          <ul className="vacant-positions-list">
            {vacantData[type].map((position, index) => (
              <li
                key={index}
                className={`vacant-item ${position.status}`}
                style={{ backgroundColor: position.status === 'vacant_more_than_20_days' ? '#FF747C' : '#F7BA1E' }}
              >
                <strong>{position.designation}</strong> in <strong>{position.project}</strong>
                <p>Status: {position.status.replace('_', ' ')}</p>
                <p>Days since vacant: {position.days_since_vacant}</p>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};


const projectNames = [
  'Tunnel Expansion',
  'Tunnel Rehab',
  'Tunnel Upgrade',
  'Tunnel Safety',
  'Tunnel Modernization',
  'Tunnel Inspection',
  'Tunnel Integrity',
  'Tunnel Access',
  'Tunnel Lighting',
  'Tunnel Maintenance',
  'Tunnel Response',
  'Tunnel Feasibility',
  'Tunnel Sustainability',
  'Tunnel Restoration',
  'Tunnel Traffic',
  'Tunnel Connectivity',
  'Tunnel Network',
  'Tunnel Capacity',
  'Tunnel Quality',
  'Tunnel Community',
  'Tunnel Survey',
  'Tunnel Digitalization',
  'Tunnel Monitoring',
  'Tunnel Training',
  'Tunnel Assessment',
  'Tunnel Drainage',
  'Tunnel Noise',
  'Tunnel Aesthetics',
  'Tunnel Pollution',
  'Tunnel Upgrade',
  'Tunnel Management',
  'Tunnel Budgeting',
  'Tunnel Compliance',
  'Tunnel Integration',
  'Tunnel Innovation',
  'Tunnel Legacy',
  'Tunnel Benefits',
  'Tunnel Art',
  'Tunnel Preparedness',
  'Tunnel Preservation',
  'Tunnel Intermodal',
  'Tunnel Collaboration',
  'Tunnel Education',
  'Tunnel Development',
  'Tunnel Green',
  'Tunnel Urban',
  'Tunnel Enhancement',
  'Tunnel Engagement',
  'Tunnel Partnership',
  'Tunnel Mobility',
  'Tunnel Future-Proofing',
  'Tunnel Sourcing',
  'Tunnel Development',
  'Tunnel Revenue',
];

const generateRandomData = () => {
  return Array.from({ length: 50 }, (_, index) => {
    const projectName = projectNames[index % projectNames.length]; // Cycle through project names
    const prCode = `PR${index + 1}`;
    const actualSalary = Math.floor(Math.random() * 10000) + 5000; // Random actual salary between 5000 and 15000
    const boqSalary = Math.floor(Math.random() * 10000) + 5000; // Random BOQ salary between 5000 and 15000

    let profit = 0;
    let loss = 0;

    let profits = actualSalary < boqSalary; // Profit if actualSalary is less than BOQ
    let losss = actualSalary > boqSalary; // Loss if actualSalary is more than BOQ

    if (boqSalary > actualSalary) {
      profit = ((actualSalary / boqSalary) * 100).toFixed(2);
    } else if (actualSalary > boqSalary) {
      loss = ((boqSalary / actualSalary) * 100).toFixed(2);
    }

    return {
      projectName,
      prCode,
      actualSalary,
      boqSalary,
      profit,
      loss,
      profits,
      losss,

    };
  });
};

const ContractorBilling = () => {

  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchEOTData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/billing-details-without-recommended-letter/`);
        setBillData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch EOT data');
        setLoading(false);
      }
    };

    fetchEOTData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500 ' style={{ padding: "0px 25px", cursor: "pointer" }}>Billing Details</h2>

      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr global-table-tr'>
              <th className='table-heading-text'>S no.</th>
              <th className='table-heading-text'>PR NO & Project Name</th>
              <th className='table-heading-text'>Contractor</th>
              <th className='table-heading-text '>Bill Details</th>
              <th className='table-heading-text text-left-sr'>Submitted</th>
              <th className='table-heading-text text-center'>Recommended</th>
              <th className='table-heading-text text-left-sr'>Other Amount</th>

            </tr>
          </thead>
          <tbody>
            {billData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className="tr-border-bottom">
                  <td colSpan="8"></td>
                </tr>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body text-left-sr'>{index + 1}.</td>
                  <td className='table-body'>{project.site_prcode} <br /><div className='whitespace-normal'>{project.project_short_name}</div>

                  </td>
                  <td className='table-body'><div className='whitespace-normal'>{project.contractorname ? project.contractorname : <p className=''>-</p>}</div></td>
                  <td className='table-body' >
                    <div >
                      <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <tbody>
                          <tr>

                            <td className="align-right table-body">
                              <div className='whitespace-normal'>
                                {project?.bill_num
                                  ? project?.bill_num
                                  : "-"}, {" "} {project?.bill_type
                                    ? project?.bill_type
                                    : "-"},{" "}  {project?.bill_catagory
                                      ? project?.bill_catagory === "balancebills" ? "Bal Bill" : project?.bill_catagory
                                      : "-"}
                              </div>
                            </td>
                          </tr>
                          {/* <tr>
                            <td className="padding-bottom-5px table-body">Type</td>
                            <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                            <td className="table-body">
                              {project?.bill_type
                                ? project?.bill_type
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <td className="padding-bottom-5px table-body">Category</td>
                            <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                            <td className="table-body">
                              {project?.bill_catagory
                                ? project?.bill_catagory
                                : "-"}
                            </td>
                          </tr> */}
                          <tr>
                            {/* <td className="padding-bottom-5px table-body">Start date</td> */}
                            {/* <td className='table-body' style={{ padding: "0px 4px" }}>:</td> */}
                            <td className="table-body">
                              {project?.bill_period_start
                                ? formatDate(project?.bill_period_start)
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            {/* <td className="padding-bottom-5px table-body">End date</td> */}
                            {/* <td className='table-body' style={{ padding: "0px 4px" }}>:</td> */}
                            <td className="table-body">
                              {project?.bill_period_end
                                ? formatDate(project?.bill_period_end)
                                : "-"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td className='table-body'>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                      <tbody>
                        <tr>
                          <td className="padding-bottom-5px table-body">Date</td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end table-body">
                            {project?.submitted_bill_date
                              ? formatDate(project?.submitted_bill_date)
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">Amount</td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="table-body text-end" >
                            {project?.submitted_bill_amount
                              ? `₹ ${formatRoundoffCrores(project?.submitted_bill_amount)}`
                              : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className='table-body'>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                      <tbody>
                        <tr>
                          <td className="padding-bottom-5px table-body">Date</td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end table-body">
                            {project?.recomended_bill_date
                              ? formatDate(project?.recomended_bill_date)
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">Amount</td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="table-body text-end" >
                            {project?.recommended_bill_amount
                              ? `₹ ${formatRoundoffCrores(project?.recommended_bill_amount)}`
                              : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td className='table-body'>
                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                      <tbody>
                        <tr>
                          <td className="padding-bottom-5px table-body">Ld </td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="text-end table-body">
                            {project?.ld_amount
                              ? `₹ ${formatRoundoffCrores(project?.ld_amount)}`
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">Withheld</td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="table-body text-end">
                            {project?.withheld_amt
                              ? `₹ ${formatRoundoffCrores(project?.withheld_amt)}`
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">Released Withheld </td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="table-body text-end">
                            {project?.released_withheld_amt
                              ? `₹ ${formatRoundoffCrores(project?.released_withheld_amt)}`
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="padding-bottom-5px table-body">Deduction </td>
                          <td className='table-body' style={{ padding: "0px 4px" }}>:</td>
                          <td className="table-body text-end">
                            {project?.deduction_amount
                              ? `₹ ${formatRoundoffCrores(project?.deduction_amount)}`
                              : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [showProfit, setShowProfit] = useState(5); // Default to showing top 10 projects
  const [showLoss, setShowLoss] = useState(5); // Default to showing top 10 projects

  useEffect(() => {
    const data = generateRandomData();
    setProjects(data);
  }, []);

  const profitProjectss = projects.filter(project => project.profits).length;
  const lossProjectss = projects.filter(project => project.losss).length;
  const totalProjects = projects.length;

  const profitPercentage = totalProjects > 0 ? ((profitProjectss / totalProjects) * 100).toFixed(2) : 0;
  const lossPercentage = totalProjects > 0 ? ((lossProjectss / totalProjects) * 100).toFixed(2) : 0;

  // Update profit projects based on the show count
  const profitProjects = projects
    .filter(project => project.profit > 0)
    .sort((a, b) => b.profit - a.profit)
    .slice(0, showProfit);

  const lossProjects = projects
    .filter(project => project.loss > 0)
    .sort((a, b) => b.loss - a.loss)
    .slice(0, showLoss); // Get top 5 loss projects

  return (
    <div className='flex-column justify-between'>

      <h2 className='text-center headingcolor'>Project Statistics</h2>

      <div className='flex-row justify-between margin-20px '>
        <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>
          <div className='flex-row justify-between'>
            <h2 className='repo-heading font-weight500'>{showProfit === 5 ? 'Top 5 Profit Projects' : showProfit === 10 ? 'Top 10 Profit Projects' : 'All Profit Projects'}</h2>
            <div>
              <select
                className='dropdown'
                name="showProjects"
                value={showProfit}
                onChange={(e) => setShowProfit(parseInt(e.target.value))}
              >
                <option value={5}> Top 5 Profit Projects</option>
                <option value={10}>Top 10 Profit Projects</option>
                <option value={projects.length}>Show All Profit Projects</option>
              </select>
            </div>
          </div>

          <div className='global-table-cont'>
            <table className='custom-table' style={{ minHeight: '311px' }}>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-center font-size-text font-weightbold'>Sno.</th>
                  <th className='align-center font-size-text font-weightbold'>Project Code</th>
                  <th className='align-center font-size-text font-weightbold'>Project Name</th>
                  <th className='align-center font-size-text font-weightbold'>Actual Salary</th>
                  <th className='align-center font-size-text font-weightbold'>BOQ Salary</th>
                  <th className='align-center font-size-text font-weightbold'>Profit (%)</th>
                </tr>
              </thead>
              <tbody>
                {profitProjects.map((project, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr className='custom-table-head-td global-table-td'>
                      <td className='align-center font-size-text font-weight400'>{index + 1}</td>
                      <td className='align-center font-size-text font-weight400'>{project.prCode}</td>
                      <td className='align-center font-size-text font-weight400'>{project.projectName}</td>
                      <td className='align-center font-size-text font-weight400'>{project.actualSalary}</td>
                      <td className='align-center font-size-text font-weight400'>{project.boqSalary}</td>
                      <td className='align-center font-size-text font-weight400 text-green'>+{project.profit}%</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>
          <div className='flex-row justify-between'>
            <h2 className='repo-heading font-weight500'>{showLoss === 5 ? 'Top 5 Loss Projects' : showLoss === 10 ? 'Top 10 Loss Projects' : 'All Loss Projects'}</h2>
            <div>
              <select
                className='dropdown'
                name="showProjects"
                value={showLoss}
                onChange={(e) => setShowLoss(parseInt(e.target.value))}
              >
                <option value={5}> Top 5 Loss Projects</option>
                <option value={10}>Top 10 Loss Projects</option>
                <option value={projects.length}>Show All Loss Projects</option>
              </select>
            </div>
          </div>
          <div className='global-table-cont'>
            <table className='custom-table' style={{ minHeight: '311px' }}>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-center font-size-text font-weightbold'>Sno.</th>
                  <th className='align-center font-size-text font-weightbold'>PR Code</th>
                  <th className='align-center font-size-text font-weightbold'>Project Name</th>
                  <th className='align-center font-size-text font-weightbold'>Actual Amount</th>
                  <th className='align-center font-size-text font-weightbold'>BOQ Amount</th>
                  <th className='align-center font-size-text font-weightbold'>Loss (%)</th>
                </tr>
              </thead>
              <tbody>
                {lossProjects.map((project, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr className='custom-table-head-td global-table-td'>
                      <td className='align-center font-size-text font-weight400'>{index + 1}</td>
                      <td className='align-center font-size-text font-weight400'>{project.prCode}</td>
                      <td className='align-center font-size-text font-weight400'>{project.projectName}</td>
                      <td className='align-center font-size-text font-weight400'>{project.actualSalary}</td>
                      <td className='align-center font-size-text font-weight400'>{project.boqSalary}</td>
                      <td className='align-center font-size-text font-weight400 text-red'>-{project.loss}%</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};





const projectNamess = [
  'Tunnel Expansion', 'Tunnel Rehab', 'Tunnel Upgrade', 'Tunnel Safety', 'Tunnel Modernization',
  'Tunnel Inspection', 'Tunnel Integrity', 'Tunnel Access', 'Tunnel Lighting', 'Tunnel Maintenance',
  'Tunnel Response', 'Tunnel Feasibility', 'Tunnel Sustainability', 'Tunnel Restoration', 'Tunnel Traffic',
  'Tunnel Connectivity', 'Tunnel Network', 'Tunnel Capacity', 'Tunnel Quality', 'Tunnel Community',
  'Tunnel Survey', 'Tunnel Digitalization', 'Tunnel Monitoring', 'Tunnel Training', 'Tunnel Assessment',
  'Tunnel Drainage', 'Tunnel Noise', 'Tunnel Aesthetics', 'Tunnel Pollution', 'Tunnel Upgrade',
  'Tunnel Management', 'Tunnel Budgeting', 'Tunnel Compliance', 'Tunnel Integration', 'Tunnel Innovation',
  'Tunnel Legacy', 'Tunnel Benefits', 'Tunnel Art', 'Tunnel Preparedness', 'Tunnel Preservation',
  'Tunnel Intermodal', 'Tunnel Collaboration', 'Tunnel Education', 'Tunnel Development', 'Tunnel Green',
  'Tunnel Urban', 'Tunnel Enhancement', 'Tunnel Engagement', 'Tunnel Partnership', 'Tunnel Mobility',
  'Tunnel Future-Proofing', 'Tunnel Sourcing', 'Tunnel Revenue'
];

const generateRandomDataa = () => {
  return Array.from({ length: 50 }, (_, index) => {
    const projectName = projectNamess[index % projectNamess.length]; // Cycle through project names
    const prCode = `PR${index + 1}`;
    const actualSalary = Math.floor(Math.random() * 10000) + 5000; // Random actual salary between 5000 and 15000
    const boqSalary = Math.floor(Math.random() * 10000) + 5000; // Random BOQ salary between 5000 and 15000
    const submitted = Math.floor(Math.random() * 20000) + 10000; // Random submitted value
    const recommended = Math.floor(Math.random() * 20000) + 10000; // Random recommended value
    const withheld = Math.floor(Math.random() * 5000); // Random withheld
    const deduction = Math.floor(Math.random() * 3000); // Random deduction
    const penalty = Math.floor(Math.random() * 2000); // Random penalty

    const difference = Math.abs(submitted - recommended);

    let profit = 0;
    let loss = 0;

    if (boqSalary > actualSalary) {
      profit = ((actualSalary / boqSalary) * 100).toFixed(2);
    } else if (actualSalary > boqSalary) {
      loss = ((boqSalary / actualSalary) * 100).toFixed(2);
    }

    return {
      projectName,
      prCode,
      actualSalary,
      boqSalary,
      profit,
      loss,
      submitted,
      recommended,
      withheld,
      deduction,
      penalty,
      difference
    };
  });
};

const ProjectListSubmitted = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const data = generateRandomDataa();
    setProjects(data);
  }, []);

  // Filter and sort for top 5 best projects based on the smallest difference between submitted and recommended
  const bestSubmittedProjects = projects
    .filter(project => project.submitted && project.recommended)
    .sort((a, b) => a.difference - b.difference)
    .slice(0, 5);

  // Filter and sort for top 5 worst projects based on the largest difference between submitted and recommended
  const worstSubmittedProjects = projects
    .filter(project => project.submitted && project.recommended)
    .sort((a, b) => b.difference - a.difference)
    .slice(0, 5);

  return (
    <div className='flex-column justify-between margin-20px bgwhite'>
      <h2 className='text-center headingcolor'>Submitted vs Recommended</h2>

      <div className='flex-row justify-between margin-20px bgwhite'>
        {/* Best 5 Projects Table */}
        <div className='invoice-cont  width-43vw  cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>
          <h2 className='repo-heading  font-weight500  '>Top 5 Best Submitted Projects</h2>
          <div className='global-table-cont'>
            <table className='custom-table'>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-left font-size-text font-weightbold'>Sno.</th>
                  <th className='align-center font-size-text font-weightbold'>Project Code</th>
                  <th className='align-center font-size-text font-weightbold'>Project Name</th>
                  <th className='align-left font-size-text font-weightbold'>Submitted</th>
                  <th className='align-left font-size-text font-weightbold'>Recommended</th>
                  <th className='align-left font-size-text font-weightbold'>Withheld</th>
                  <th className='align-left font-size-text font-weightbold'>Deduction</th>
                  <th className='align-left font-size-text font-weightbold'>Penalty</th>
                  <th className='align-left font-size-text font-weightbold'>Difference</th>
                </tr>
              </thead>
              <tbody>
                {bestSubmittedProjects.map((project, index) => (
                  <tr className='custom-table-head-td global-table-td' key={index}>
                    <td className='align-center font-size-text font-weight400'>{index + 1}</td>
                    <td className='align-center font-size-text font-weight400'>{project.prCode}</td>
                    <td className='align-center font-size-text font-weight400'>{project.projectName}</td>
                    <td className='align-center font-size-text font-weight400'>{project.submitted}</td>
                    <td className='align-center font-size-text font-weight400'>{project.recommended}</td>
                    <td className='align-center font-size-text font-weight400'>{project.withheld}</td>
                    <td className='align-center font-size-text font-weight400'>{project.deduction}</td>
                    <td className='align-center font-size-text font-weight400'>{project.penalty}</td>
                    <td className='align-center font-size-text font-weight400'>{project.difference}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Worst 5 Projects Table */}
        <div className='invoice-cont  width-43vw  cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>
          <h2 className='repo-heading  font-weight500  '>Top 5 Worst Submitted Projects</h2>
          <div className='global-table-cont'>
            <table className='custom-table'>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-left font-size-text font-weightbold'>Sno.</th>
                  <th className='align-center font-size-text font-weightbold'>Project Code</th>
                  <th className='align-left font-size-text font-weightbold'>Project Name</th>
                  <th className='align-left font-size-text font-weightbold'>Submitted</th>
                  <th className='align-left font-size-text font-weightbold'>Recommended</th>
                  <th className='align-left font-size-text font-weightbold'>Withheld</th>
                  <th className='align-left font-size-text font-weightbold'>Deduction</th>
                  <th className='align-left font-size-text font-weightbold'>Penalty</th>
                  <th className='align-left font-size-text font-weightbold'>Difference</th>
                </tr>
              </thead>
              <tbody>
                {worstSubmittedProjects.map((project, index) => (
                  <>
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="8"></td>
                      </tr>
                      <tr className='custom-table-head-td global-table-td' key={index}>
                        <td className='align-center font-size-text font-weight400'>{index + 1}</td>
                        <td className='align-center font-size-text font-weight400'>{project.prCode}</td>
                        <td className='align-center font-size-text font-weight400'>{project.projectName}</td>
                        <td className='align-center font-size-text font-weight400'>{project.submitted}</td>
                        <td className='align-center font-size-text font-weight400'>{project.recommended}</td>
                        <td className='align-center font-size-text font-weight400'>{project.withheld}</td>
                        <td className='align-center font-size-text font-weight400'>{project.deduction}</td>
                        <td className='align-center font-size-text font-weight400'>{project.penalty}</td>
                        <td className='align-center font-size-text font-weight400'>{project.difference}</td>
                      </tr>
                    </React.Fragment>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};





// Letter Types and Subcategories
const letterTypes = {
  Contractor: [
    'Show Cause',
    'Informative',
    'EOT',
    'COS',
    'Billing',
    'Design',
    'NCR',
  ],
  Consultant: [
    'Show Cause',
    'Informative',
    'EOT',
    'COS',
    'Billing',
    'Design',
    'NCR',
  ],
};

// Generate random letter data
const generateRandomLetters = () => {
  const letters = [];
  for (let i = 1; i <= 60; i++) {
    const type =
      Math.random() > 0.5
        ? 'Contractor'
        : 'Consultant'; // Randomly choose type
    const subcategory =
      letterTypes[type][Math.floor(Math.random() * letterTypes[type].length)];
    const letterId = `LTR-${i}`;
    const date = new Date(
      Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 30) // Random date within the last month
    ).toLocaleDateString();

    letters.push({
      id: letterId,
      type,
      subcategory,
      date,
    });
  }
  return letters;
};

const LetterList = () => {
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    const data = generateRandomLetters();
    setLetters(data);
  }, []);

  // Count letters by type and subcategory
  const countLetters = () => {
    const counts = {
      Contractor: {
        'Show Cause': 0,
        Informative: 0,
        EOT: 0,
        COS: 0,
        Billing: 0,
        Design: 0,
        NCR: 0,
      },
      Consultant: {
        'Show Cause': 0,
        Informative: 0,
        EOT: 0,
        COS: 0,
        Billing: 0,
        Design: 0,
        NCR: 0,
      },
    };

    letters.forEach(letter => {
      const { type, subcategory } = letter;
      counts[type][subcategory] += 1;
    });

    return counts;
  };

  const counts = countLetters();

  return (
    <div className='flex-column justify-between margin-20px bgwhite'>
      <h2 className='text-center headingcolor'>Letter Statistics</h2>

      <div className='flex-row justify-between margin-20px'>
        <div className='invoice-cont  width-30vw  cont-col cards-shadow2 bgwhite transaction-cont  box-shadow margin-20px'>

          <h2 className='repo-heading  font-weight500  '>Letters List</h2>
          <div className='global-table-cont'>

            <table className='custom-table'>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-center font-size-text font-weightbold'>Work Performed By</th>
                  <th className='align-left font-size-text font-weightbold'>Show Cause</th>
                  <th className='align-left font-size-text font-weightbold'>Informative</th>
                  <th className='align-left font-size-text font-weightbold'>EOT</th>
                  <th className='align-left font-size-text font-weightbold'>COS</th>
                  <th className='align-left font-size-text font-weightbold'>Billing</th>
                  <th className='align-left font-size-text font-weightbold'>Design</th>
                  <th className='align-left font-size-text font-weightbold'>NCR</th>
                </tr>
              </thead>
              <tbody>
                <React.Fragment >
                  <tr className="tr-border-bottom">
                    <td colSpan="8"></td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td' >
                    <td className='align-center font-size-text font-weight400'>Contractor</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor['Show Cause']}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.Informative}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.EOT}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.COS}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.Billing}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.Design}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Contractor.NCR}</td>
                  </tr>

                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Authority</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant['Show Cause']}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.Informative}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.EOT}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.COS}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.Billing}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.Design}</td>
                    <td className='align-center font-size-text font-weight400'>{counts.Consultant.NCR}</td>
                  </tr>
                </React.Fragment>
              </tbody>
            </table>

          </div>
        </div>
        <div className='invoice-cont  width-20vw  cont-col cards-shadow2 bgwhite transaction-cont  box-shadow margin-20px'>

          <h2 className='repo-heading  font-weight500  '>Letters Status of Cosultant</h2>
          <div className='global-table-cont'>

            <table className='custom-table'>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-left font-size-text font-weightbold'>Letter Type</th>
                  <th className='align-left font-size-text font-weightbold'>Pending</th>
                  <th className='align-left font-size-text font-weightbold'>Complete</th>
                  <th className='align-left font-size-text font-weightbold'>Inprogress</th>
                  <th className='align-left font-size-text font-weightbold'>Close</th>

                </tr>
              </thead>
              <tbody>
                <React.Fragment >
                  <tr className="tr-border-bottom">
                    <td colSpan="8"></td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td' >
                    <td className='align-center font-size-text font-weight400'>Eot</td>
                    <td className='align-center font-size-text font-weight400'>20</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>7</td>
                    <td className='align-center font-size-text font-weight400'>5</td>

                  </tr>

                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Cos</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Informative</td>
                    <td className='align-center font-size-text font-weight400'>20</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>7</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>ShowCause</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Cos</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                </React.Fragment>
              </tbody>
            </table>

          </div>
        </div>
        <div className='invoice-cont  width-20vw  cont-col cards-shadow2 bgwhite transaction-cont  box-shadow margin-20px'>

          <h2 className='repo-heading  font-weight500  '>Letters Status of Contractor</h2>
          <div className='global-table-cont'>

            <table className='custom-table'>
              <thead className='heading'>
                <tr className='custom-table-head-tr global-table-tr'>
                  <th className='align-left font-size-text font-weightbold'>Letter Type</th>
                  <th className='align-left font-size-text font-weightbold'>Pending</th>
                  <th className='align-left font-size-text font-weightbold'>Complete</th>
                  <th className='align-left font-size-text font-weightbold'>Inprogress</th>
                  <th className='align-left font-size-text font-weightbold'>Close</th>

                </tr>
              </thead>
              <tbody>
                <React.Fragment >
                  <tr className="tr-border-bottom">
                    <td colSpan="8"></td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td' >
                    <td className='align-center font-size-text font-weight400'>Eot</td>
                    <td className='align-center font-size-text font-weight400'>20</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>7</td>
                    <td className='align-center font-size-text font-weight400'>5</td>

                  </tr>

                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Cos</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Informative</td>
                    <td className='align-center font-size-text font-weight400'>20</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>7</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>ShowCause</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                  <tr className='custom-table-head-td global-table-td'>
                    <td className='align-center font-size-text font-weight400'>Cos</td>
                    <td className='align-center font-size-text font-weight400'>10</td>
                    <td className='align-center font-size-text font-weight400'>5</td>
                    <td className='align-center font-size-text font-weight400'>6</td>
                    <td className='align-center font-size-text font-weight400'>3</td>
                  </tr>
                </React.Fragment>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  );
};



// Generate random project data
const generateRandomDatas = () => {
  return Array.from({ length: 50 }, (_, index) => {
    const projectName = projectNames[index % projectNames.length]; // Cycle through project names
    const prCode = `PR${index + 1}`;
    const payment = Math.floor(Math.random() * 50000) + 10000; // Random payment between 10000 and 60000
    const deduction = Math.floor(Math.random() * 5000); // Random deduction
    const GST = Math.floor(Math.random() * 3000); // Random GST
    const withheld = Math.floor(Math.random() * 2000); // Random withheld amount
    const daysAfterSubmission = Math.floor(Math.random() * 30) + 1; // Random days after submission between 1 and 30

    return {
      projectName,
      prCode,
      payment,
      deduction,
      GST,
      withheld,
      daysAfterSubmission
    };
  });
};

const ProjectLists = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const data = generateRandomDatas();
    setProjects(data);
  }, []);

  // Sort the projects by daysAfterSubmission in descending order and get the top 5
  const topDelayedProjects = projects
    .sort((a, b) => b.daysAfterSubmission - a.daysAfterSubmission)
    .slice(0, 5);

  return (
    <div className='flex-column justify-between margin-20px bgwhite'>
      <h2 className='text-center headingcolor '>Payment Statistics</h2>

      <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>
        <h2 className='repo-heading font-weight500 '>Billing Information</h2>
        <div className='global-table-cont'>
          <table className='custom-table' style={{ minHeight: '311px' }}>
            <thead className='heading'>
              <tr className='custom-table-head-tr global-table-tr'>
                <th className='align-center font-size-text font-weightbold'>Sno.</th>
                <th className='align-center font-size-text font-weightbold'>PR Code</th>
                <th className='align-center font-size-text font-weightbold'>Project Name</th>
                <th className='align-center font-size-text font-weightbold'>Payment</th>
                <th className='align-center font-size-text font-weightbold'>Deduction</th>
                <th className='align-center font-size-text font-weightbold'>GST</th>
                <th className='align-center font-size-text font-weightbold'>Withheld</th>

                <th className='align-center font-size-text font-weightbold'>Days After Submission</th>
              </tr>
            </thead>
            <tbody>
              {topDelayedProjects.map((project, index) => (
                <tr className='custom-table-head-td global-table-td' >
                  <td className='align-center font-size-text font-weight400'>{index + 1}</td>
                  <td className='align-center font-size-text font-weight400'>{project.prCode}</td>
                  <td className='align-center font-size-text font-weight400'>{project.projectName}</td>
                  <td className='align-center font-size-text font-weight400'>{project.payment}</td>
                  <td className='align-center font-size-text font-weight400'>{project.deduction}</td>
                  <td className='align-center font-size-text font-weight400'>{project.GST}</td>
                  <td className='align-center font-size-text font-weight400'>{project.withheld}</td>
                  <td className='align-center font-size-text font-weight400'>{project.daysAfterSubmission}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};



const VacantListt = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/vacant-positions-status/`);
        setProjects(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch project data');
        setLoading(false);
      }
    };

    fetchProjectData();
  }, []);


  const getShortForm = (designation) => {
    const shortForms = {
      'Team Leader Cum Senior Highway Engineer': 'TL/SHE',
      'Team Leader Cum Senior Bridge/ Structural Engineer': 'TL/SBSE',
      'Bridge / Structural Engineer': 'BSE',
      'Senior Architect': 'SA',
      'Assistant Bridge Engineer': 'ABE',
      'Bridge/Structure Design Engineer': 'BSDE',
      // Add more mappings as needed
    };

    // Return the short form if it exists, otherwise return the original designation
    return shortForms[designation] || designation;
  };

  // Modify remarks to use short form
  const getShortFormRemarks = (remarks) => {
    const match = remarks.match(/^(.+?),\s*(-?\d+)\s*days\s*left$/);
    if (!match) return remarks;

    const designation = match[1].trim();
    const daysLeft = match[2].trim();

    // Get the short form of the designation
    const shortFormDesignation = getShortForm(designation);

    return `${shortFormDesignation}, ${daysLeft} days left`;
  };

  // Function to determine the text color based on the days left
  const getColorForDaysLeft = (remarks) => {
    // Extract the number of days left from the remarks
    const match = remarks.match(/(-?\d+)\s*days\s*left/);
    if (!match) return 'black'; // Default color if no days left is specified

    const daysLeft = parseInt(match[1], 10);

    // Apply color logic based on days left
    if (daysLeft > 10) {
      return 'black';
    } else if (daysLeft >= 5 && daysLeft <= 10) {
      return 'green';
    } else {
      return 'red';
    }
  };





  return (

    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <h2 className='repo-heading font-weight500 padding-heading'>Vacant Positions</h2>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px", maxHeight: '' }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>PR NO & Name</th>
              {/* <th className='align-center font-size-text font-weightbold'>Name</th> */}
              <th className='table-heading-text text-center'>KP</th>
              <th className='table-heading-text text-center'>SP</th>
              <th className='table-heading-text text-center'>SS</th>
              <th className='table-heading-text text-center'>Total Vacant</th>
              <th className='table-heading-text text-right'>Remark</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>

                  <td className='table-body'><div className='whitespace-normal'>{project.pr_no} &
                    {project.project_short_name}</div></td>

                  <td className='table-body text-center'>{project.key_professionals ? project.key_professionals : "-"}</td>
                  <td className='table-body text-center'>{project.sub_professionals ? project.sub_professionals : "-"}</td>
                  <td className='table-body text-center'>{project.support_staff ? project.support_staff : "-"}</td>
                  <td className='table-body text-center'>{project.total_vacant_positions ? project.total_vacant_positions : "-"}</td>
                  <td
                    className='table-body text-right'
                    style={{ color: getColorForDaysLeft(project.remarks) }}
                  >
                    <div className='whitespace-normal'>
                      {getShortFormRemarks(project.remarks ? project.remarks : "-")}
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
};


const VacantList = () => {
  const [projects, setProjects] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [professionalType, setProfessionalType] = useState('null'); // 'all', 'Key Professional', 'Sub Professional', 'Support Staff'

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/vacant-employee-by-designation-project/${professionalType}/`);
        setProjects(response.data);
        setFilteredData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch project data');
        setLoading(false);
      }
    };

    fetchProjectData();
  }, []);

  // Update filtered data when viewType or professionalType changes





  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px'>


      <div className="table-heading-flex">
        <div><h2 className='dashboard-card-heading-blue font-weight500'>Vacant Positions</h2></div>

        <div className="table-searchh"> <select
          value={professionalType}
          onChange={(e) => setProfessionalType(e.target.value)}

          style={{ border: "none" }}

          className='navbar-inputt font-weight400  font-size-text'
        >
          <option value='null'>All Types</option>
          <option value='Key Professional'>Key Professionals</option>
          <option value='Sub Professional'>Sub Professionals</option>
          <option value='Support Staff'>Support Staff</option>
        </select></div>
      </div>


      <div className='global-table-cont'>

        <table className='custom-table' style={{ minHeight: '311px' }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr-with-less-padding global-table-tr'>
              <th className='align-leftt font-size-text font-weightbold'>Desigantion Name</th>

              <th className='align-leftt font-size-text font-weightbold'> Project</th>

              {professionalType === 'null' ? <th className='align-center font-size-text font-weightbold'>Professional Type</th> : ""}

            </tr>
          </thead>
          <tbody>
            {projects.sort((a, b) => b.designation_name.localeCompare(a.designation_name)).map((item, index) => (
              <tr key={index} className='custom-table-head-td-with-less-padding global-table-td'>
                <td className='align-leftt font-size-text font-weight400'>
                  {item.designation_name}
                </td>

                <td className='align-center font-size-text font-weight400'>

                  <EmployeeDesignationWiseModel count={item.projects.length} projectdata={item.projects} />

                </td>

                {professionalType === "null" ? <td className='align-center'>
                  {item.professional_type}
                </td> : ""}



              </tr>
            ))

            }
          </tbody>
        </table>

      </div>
    </div>
  );
};



const EOTDashboard = () => {
  const [eotData, setEotData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchEOTData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/eotdashboard/${status}/`);
        setEotData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch EOT data');
        setLoading(false);
      }
    };

    fetchEOTData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  const navigate = useNavigate()
  const gotoEotdetails = (project, project_code) => {

    navigate(`/admin/detailspage/`, {
      state: {
        toggle: 2,
      }
    });
  };

  return (
    <div className='invoice-cont  width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>EOT Project</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ borderColor: "#9ec2e1" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className="table-css">
          <thead className='table-heading'>
            <tr className="custom-table-head-tr">
              <th className="table-heading-text text-lefttt">S. No.</th>
              <th className="table-heading-text">EOT Code</th>
              <th className="table-heading-text">Date</th>
              <th className="table-heading-text">Days</th>
              <th className="table-heading-text">Letters</th>
              <th className="table-heading-text">Status</th>

            </tr>
          </thead>

          <tbody>
            {eotData?.map((i, index) => (
              <React.Fragment key={index}>

                <tr className="custom-table-head-td"
                  onClick={() => gotoEotdetails()}
                  title="click to go on detail page">
                  <td className="table-body text-lefttt" >{`${index + 1} .`}</td>
                  <td className="table-body">{i.eot_code}</td>
                  {i.process_initiate_date || i.approved_date ?
                    <td className="table-body ">

                      <tr>
                        <td className="padding-bottom-5px">
                          Initiate
                        </td>
                        <td style={{ padding: "0px 4px" }}>:</td>
                        <td className="text-end" >
                          {i.process_initiate_date ? i.process_initiate_date : <div className="text-center">-</div>}
                        </td>
                      </tr>
                      <tr>
                        <td className="padding-bottom-5px">
                          {i.eot_status !== "Approved" ? "Rejected" : "Approved"}
                        </td>
                        <td style={{ padding: "0px 4px" }}>:</td>
                        <td className="text-end">
                          {i.approved_date ? i.approved_date : <div className="text-center">-</div>}
                        </td>
                      </tr>

                    </td> :
                    <td className="table-body ">No Letters Attached</td>
                  }
                  {/* {i.days || i.approved_days ? */}
                  <td className="table-body ">

                    <tr>
                      <td className="padding-bottom-5px">
                        Initiate
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end" >
                        {i.days ? i.days : <div className="text-center">-</div>}
                      </td>
                    </tr>
                    <tr>
                      <td className="padding-bottom-5px">
                        Approved
                      </td>
                      <td style={{ padding: "0px 4px" }}>:</td>
                      <td className="text-end">
                        {i.approved_days ? i.approved_days : <div className="text-center">-</div>}
                      </td>
                    </tr>

                  </td>
                  {/* //   :
                  //   <td className="table-body ">No Letters Attached</td>
                  // } */}
                  {i.letter || i.close_letter ?
                    <td className="table-body ">

                      <tr>
                        <td className="padding-bottom-5px">
                          Initiate
                        </td>
                        <td style={{ padding: "0px 4px" }}>:</td>
                        <td className="text-end padding2px" >
                          {i.letter ? <ViewLetterModal i={i.letter} /> : <div className="text-center">No Letter Attached</div>}
                        </td>
                      </tr>
                      <tr >
                        <td className="padding-bottom-5px">
                          Close
                        </td>
                        <td style={{ padding: "0px 4px" }}>:</td>
                        <td className="text-end padding2px">
                          {i.close_letter ? <ViewLetterModal i={i.close_letter} /> : <div className="text-center">No Letter Attached</div>}
                        </td>
                      </tr>

                    </td> :
                    <td className="table-body ">No Letters Attached</td>
                  }

                  <td className="table-body" style={{ textTransform: "capitalize" }}>{i.eot_status}</td>




                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {/* <div className='custom-table' style={{minHeight:"311px"}}>
          {eotData.map((eot, index) => (
            <div key={eot.id} className='eot-list custom-table-head-td-with-less-padding global-table-td'>
              <div className='eot-header flex-column'>
                <div className='flex-row'>
                  <div>
                    <span className='eot-code'>{eot.eot_code}</span></div>
                  <div>
                    <p className='eot-project-name'>{eot.project_code}<br />{eot.project_short_name}</p>
                  </div>
                </div>

                <p>

                  Contractor: <strong>{eot.contractor_name}</strong>

                </p>
              </div>
              <div className='eot-details align-right'>

                {status === 'approved' ? (
                  <>
                    <p>
                      No of Days: <span className='days-left' style={{ color: 'green' }}>
                        {eot.approved_days}
                      </span>
                    </p>
                    <br />
                    <p>
                      Approval Date: <span className='approval-date'>
                        {new Date(eot.approved_date).toLocaleDateString()}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      Letter Number: <span className='letter-number'>{eot.letter_number}</span>
                    </p>
                    <p>
                      Process Initiate Date: <span className='process-initiate-date'>
                        {eot.process_initiate_date ? new Date(eot.process_initiate_date).toLocaleDateString() : 'N/A'}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div> */}

      </div>
    </div>
  );
};


const PNLDashboard = () => {
  const [eotData, setEotData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchEOTData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/eotdashboard/${status}/`);
        setEotData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch EOT data');
        setLoading(false);
      }
    };

    fetchEOTData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  return (
    <div className='invoice-cont  width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Profit and Loss</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ borderColor: "#9ec2e1" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>PR NO & Project Name</th>
              <th className='table-heading-text'>EOT Code</th>
              <th className='table-heading-text'>Letter No.</th>
              {/* <th className='align-center font-size-text font-weightbold'>Name</th> */}
              <th className='table-heading-text'>Contractor</th>
              <th className='table-heading-text text-center'>No. of Days</th>
              {status === "pending" ?
                <th className='table-heading-text '>Initiated Date</th>
                :
                <th className='table-heading-text '>Approval Date</th>
              }
              {/* <th className='table-heading-text'>Remark</th> */}
            </tr>
          </thead>
          <tbody>
            {eotData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'><div className='whitespace-normal'>{project.project_code} &
                    {project.project_short_name}</div></td>
                  <td className='table-body'>{project.eot_code}</td>
                  <td className='table-body'>{project.letter_number}</td>
                  <td className='table-body '>{project.contractor_name ? project.contractor_name : "-"}</td>
                  <td className='table-body text-center'>{project.approved_days ? project.approved_days : "-"}</td>
                  {status === "pending" ?
                    <td className='table-body '>{project.process_initiate_date ? formatDate(project.process_initiate_date) : "-"}</td>
                    :
                    <td className='table-body '>{project.approved_date ? formatDate(project.approved_date) : "-"}</td>
                  }
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {/* <div className='custom-table' style={{minHeight:"311px"}}>
          {eotData.map((eot, index) => (
            <div key={eot.id} className='eot-list custom-table-head-td-with-less-padding global-table-td'>
              <div className='eot-header flex-column'>
                <div className='flex-row'>
                  <div>
                    <span className='eot-code'>{eot.eot_code}</span></div>
                  <div>
                    <p className='eot-project-name'>{eot.project_code}<br />{eot.project_short_name}</p>
                  </div>
                </div>

                <p>

                  Contractor: <strong>{eot.contractor_name}</strong>

                </p>
              </div>
              <div className='eot-details align-right'>

                {status === 'approved' ? (
                  <>
                    <p>
                      No of Days: <span className='days-left' style={{ color: 'green' }}>
                        {eot.approved_days}
                      </span>
                    </p>
                    <br />
                    <p>
                      Approval Date: <span className='approval-date'>
                        {new Date(eot.approved_date).toLocaleDateString()}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      Letter Number: <span className='letter-number'>{eot.letter_number}</span>
                    </p>
                    <p>
                      Process Initiate Date: <span className='process-initiate-date'>
                        {eot.process_initiate_date ? new Date(eot.process_initiate_date).toLocaleDateString() : 'N/A'}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div> */}

      </div>
    </div>
  );
};


const InovoiceDashboard = () => {
  const [eotData, setEotData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchEOTData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/eotdashboard/${status}/`);
        setEotData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch EOT data');
        setLoading(false);
      }
    };

    fetchEOTData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  return (
    <div className='invoice-cont  width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Invoice</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ borderColor: "#9ec2e1" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>PR NO & Project Name</th>
              <th className='table-heading-text'>EOT Code</th>
              <th className='table-heading-text'>Letter No.</th>
              {/* <th className='align-center font-size-text font-weightbold'>Name</th> */}
              <th className='table-heading-text'>Contractor</th>
              <th className='table-heading-text text-center'>No. of Days</th>
              {status === "pending" ?
                <th className='table-heading-text '>Initiated Date</th>
                :
                <th className='table-heading-text '>Approval Date</th>
              }
              {/* <th className='table-heading-text'>Remark</th> */}
            </tr>
          </thead>
          <tbody>
            {eotData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'><div className='whitespace-normal'>{project.project_code} &
                    {project.project_short_name}</div></td>
                  <td className='table-body'>{project.eot_code}</td>
                  <td className='table-body'>{project.letter_number}</td>
                  <td className='table-body '>{project.contractor_name ? project.contractor_name : "-"}</td>
                  <td className='table-body text-center'>{project.approved_days ? project.approved_days : "-"}</td>
                  {status === "pending" ?
                    <td className='table-body '>{project.process_initiate_date ? formatDate(project.process_initiate_date) : "-"}</td>
                    :
                    <td className='table-body '>{project.approved_date ? formatDate(project.approved_date) : "-"}</td>
                  }
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {/* <div className='custom-table' style={{minHeight:"311px"}}>
          {eotData.map((eot, index) => (
            <div key={eot.id} className='eot-list custom-table-head-td-with-less-padding global-table-td'>
              <div className='eot-header flex-column'>
                <div className='flex-row'>
                  <div>
                    <span className='eot-code'>{eot.eot_code}</span></div>
                  <div>
                    <p className='eot-project-name'>{eot.project_code}<br />{eot.project_short_name}</p>
                  </div>
                </div>

                <p>

                  Contractor: <strong>{eot.contractor_name}</strong>

                </p>
              </div>
              <div className='eot-details align-right'>

                {status === 'approved' ? (
                  <>
                    <p>
                      No of Days: <span className='days-left' style={{ color: 'green' }}>
                        {eot.approved_days}
                      </span>
                    </p>
                    <br />
                    <p>
                      Approval Date: <span className='approval-date'>
                        {new Date(eot.approved_date).toLocaleDateString()}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      Letter Number: <span className='letter-number'>{eot.letter_number}</span>
                    </p>
                    <p>
                      Process Initiate Date: <span className='process-initiate-date'>
                        {eot.process_initiate_date ? new Date(eot.process_initiate_date).toLocaleDateString() : 'N/A'}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div> */}

      </div>
    </div>
  );
};


const COSDashboard = () => {
  const [eotData, setEotData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchEOTData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/cosdashboard/${status}/`);
        setEotData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch EOT data');
        setLoading(false);
      }
    };

    fetchEOTData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  console.log(eotData)


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>COS Project</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ border: "none" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>PR NO & Project Name</th>
              <th className='table-heading-text'>COS Code</th>
              <th className='table-heading-text'>Letter No.</th>
              {/* <th className='align-center font-size-text font-weightbold'>Name</th> */}
              <th className='table-heading-text'>Contractor</th>
              <th className='table-heading-text text-end'>Amount</th>
              {status === "pending" ?
                <th className='table-heading-text '>Initiated Date</th>
                :
                <th className='table-heading-text '>Approval Date</th>
              }
              {/* <th className='table-heading-text'>Remark</th> */}
            </tr>
          </thead>
          <tbody>
            {eotData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  {/* <td className='table-body'><div className='whitespace-normal'>{project.project_code} &
                    {project.project_short_name}</div></td> */}
                  <td className='table-body'>{project.project_code}:<br />{project.project_short_name}</td>
                  <td className='table-body'>{project.cos_code}</td>
                  <td className='table-body'>{project.letter_number}</td>
                  <td className='table-body '>{project.contractor_name ? project.contractor_name : "-"}</td>
                  <td className='table-body text-end'>₹{project.amount ? formatCurrencyIndian(project.amount) : "-"}</td>
                  {status === "pending" ?
                    <td className='table-body '>{project.process_initiate_date ? formatDate(project.process_initiate_date) : "-"}</td>
                    :
                    <td className='table-body '>{project.approval_date ? formatDate(project.approval_date) : "-"}</td>
                  }
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const Progress = () => {
  const [progressData, setProgressData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchProgressData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/progressbyproject/null/null/null/null/`);
        setProgressData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch Mitlstone data');
        setLoading(false);
      }
    };

    fetchProgressData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
  const getMonthName = (monthNumber) => {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[monthNumber - 1];
  };

  console.log(progressData)


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Progress</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ border: "none" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>Project Name</th>
              <th className='table-heading-text'>Month</th>
              <th className='table-heading-text'>Year</th>
              <th className='table-heading-text'>Approved Progress (%)</th>
            </tr>
          </thead>
          <tbody>
            {progressData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'>
                    {project.site_prcode ? `${project.site_prcode}:` : "-"}<br />
                    {project.project_name ? project.project_name : ""}
                  </td>
                  <td className='table-body'>{getMonthName(project.month)}</td>
                  <td className='table-body'>{project.year}</td>
                  <td className='table-body '>
                    <div className="flex-column-center">
                      {project.approved_letter && project.physical_progress && project.financial_progress ? (
                        <>

                          <tr className="">

                            <td className="padding-bottom-5px" style={{ textAlign: "start" }}>Physical Progress</td>
                            <td style={{ padding: "0px 4px" }}>:</td>

                            <td className="align-right" style={{ textAlign: "start" }}>{project.physical_progress || "-"}</td>
                          </tr>
                          <tr className="">

                            <td className="padding-bottom-5px" style={{ textAlign: "start" }}>Financial Progress</td>
                            <td style={{ padding: "0px 4px" }}>:</td>

                            <td className="align-right" style={{ textAlign: "start" }}>{project.financial_progress || "-"}</td>
                          </tr>

                        </>
                      ) : <p className="text-center"> -</p>}
                    </div>
                  </td>

                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const Milestone = () => {
  const [milestoneData, setMilestoneData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [project, setProject] = useState("null");
  const [contractor, setContractor] = useState("null");
  const [rescheduleFromDate, setRescheduleFromDate] = useState("null");
  const [rescheduleToDate, setRescheduleToDate] = useState("null");
  const [actualFromDate, setActualFromDate] = useState("null");
  const [actualToDate, setActualToDate] = useState("null");
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchMilestoneData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/milestonefilterss/${project}/${contractor}/${rescheduleFromDate}/${rescheduleToDate}/${actualFromDate}/${actualToDate}/`);
        setMilestoneData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch Mitlstone data');
        setLoading(false);
      }
    };

    fetchMilestoneData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  console.log(milestoneData, 'milestone')


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Milestone</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ border: "none" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>PR NO & Project Name</th>
              <th className='table-heading-text'>Milestone Name</th>
              <th className='table-heading-text'>Contractor Name</th>
              {/* <th className='align-center font-size-text font-weightbold'>Name</th> */}
              {/* <th className='table-heading-text'>Contractor</th>
              <th className='table-heading-text text-end'>Amount</th>
              {status === "pending" ?
                <th className='table-heading-text '>Initiated Date</th>
                :
                <th className='table-heading-text '>Approval Date</th>
              } */}
              {/* <th className='table-heading-text'>Remark</th> */}
            </tr>
          </thead>
          <tbody>
            {milestoneData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'>
                    {project.site_prcode ? `${project.site_prcode}:` : "-"}<br />
                    {project.project_name ? project.project_name : ""}
                  </td>

                  <td className='table-body'>{project.name ? project.name : "-"}</td>
                  <td className='table-body '>{project.contractor_name ? project.contractor_name : "-"}</td>
                  {/* <td className='table-body text-end'>₹{project.amount ? formatCurrencyIndian(project.amount) : "-"}</td>
                  {status === "pending" ?
                    <td className='table-body '>{project.process_initiate_date ? formatDate(project.process_initiate_date) : "-"}</td>
                    :
                    <td className='table-body '>{project.approval_date ? formatDate(project.approval_date) : "-"}</td>
                  } */}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const BankGuarantee = () => {
  const [bankGuranteeData, setBankGuranteeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [project, setProject] = useState("null");
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchBankData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/bgfilter/${project}/null/null/null/null/`);
        setBankGuranteeData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch Mitlstone data');
        setLoading(false);
      }
    };

    fetchBankData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  console.log(bankGuranteeData)


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Bank Guarantee</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ border: "none" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>Bank Name</th>
              <th className='table-heading-text'>Bank Number</th>
              <th className='table-heading-text'>Start Date</th>
              <th className='table-heading-text'>Expiry Date</th>
            </tr>
          </thead>
          <tbody>
            {bankGuranteeData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'>{project.bank_name}</td>
                  <td className='table-body'>{project.bg_num}</td>
                  <td className='table-body'>{formattedDateLong(project.bg_date)}</td>
                  <td className='table-body'>{formattedDateLong(project.bg_expiry_date)}</td>

                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Insurance = () => {
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [project, setProject] = useState("null");
  const [status, setStatus] = useState('pending'); // Default to 'pending'

  // Fetch data from the API based on the selected status
  useEffect(() => {
    const fetchInsuranceData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/insurencefilter/${project}/null/null/null/null/`);
        setInsuranceData(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch Mitlstone data');
        setLoading(false);
      }
    };

    fetchInsuranceData();
  }, [status]);

  // Handle status change from the dropdown
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };


  console.log(insuranceData)


  return (
    <div className='invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow' style={{ margin: "10px" }}>
      <div className='dashboard-header'>
        <h2 className='repo-heading font-weight500' style={{ padding: "0px 25px" }}>Insurance</h2>
        <select className='status-dropdown' value={status} onChange={handleStatusChange} style={{ border: "none" }}>
          <option value='pending'>Pending</option>
          <option value='Approved'>Approved</option>
        </select>
      </div>
      <div className='global-table-cont scroll-container-table no-max-height' style={{ minHeight: "311px" }}>
        <table className='custom-table' style={{ minHeight: "311px" }}>
          <thead className='heading'>
            <tr className='custom-table-head-tr'>
              <th className='table-heading-text'>S.no.</th>
              <th className='table-heading-text'>Policy Number</th>
              <th className='table-heading-text'>Insurance Name</th>
              <th className='table-heading-text'>Amount</th>
              <th className='table-heading-text'>Start Date</th>
              <th className='table-heading-text'>Valid Upto</th>
            </tr>
          </thead>
          <tbody>
            {insuranceData.map((project, index) => (
              <React.Fragment key={index}>
                <tr className='custom-table-head-td global-table-td'>
                  <td className='table-body'>{index + 1}.</td>
                  <td className='table-body'>{project.insurance_policy_num}:<br />{project.project_short_name}</td>
                  <td className='table-body'>{project.insurance_name}</td>
                  <td className='table-body'>{project.insurance_amount}</td>
                  <td className='table-body'>{formattedDateLong(project.insurance_policy_start_date)}</td>
                  <td className='table-body'>{formattedDateLong(project.insurance_policy_valid_upto_date)}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};


const LetterSummary = () => {
  const [letterSummary, setLetterSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLetterSummary = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/letter-summary/`);
        setLetterSummary(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch letter summary');
        setLoading(false);
      }
    };

    fetchLetterSummary();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const letterTypes = ['Show Cause', 'Informative', 'EOT', 'COS', 'Billing'];

  return (
    <div className='letter-summary-container'>
      <h2 className='summary-heading'>Letter List</h2>
      <div className='letter-summary'>
        <table className='summary-table'>
          <thead>
            <tr>
              <th>Ltter</th>
              {letterTypes.map((type) => (
                <th key={type} colSpan={2} className='align-center'>{type}</th>
              ))}
            </tr>
            <tr>
              <th></th>
              {letterTypes.map((type) => (
                <>
                  <th key={`${type}-consultant`} className='align-center'>Consultant</th>
                  <th key={`${type}-contractor`} className='align-center'>Contractor</th>
                </>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(letterSummary).map(([status, roles], index) => (
              <tr key={index}>
                <td className='align-left'>{status}</td>
                {letterTypes.map((type) => (
                  <>
                    <td key={`${status}-${type}-consultant`} className='align-center'>
                      {roles.Consultant[type] || 0}
                    </td>
                    <td key={`${status}-${type}-contractor`} className='align-center'>
                      {roles.Contractor[type] || 0}
                    </td>
                  </>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};




const LetterTypeTable = () => {
  const [letterdata, setLetterdata] = useState({});
  const [categories, setCategories] = useState([]); // Dynamic categories

  useEffect(() => {
    const fetchEOTData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/letter-summary/`);
        const data = response.data;
        setLetterdata(data);

        // Extract categories dynamically from the response
        const firstType = Object.values(data)[0]; // Get the first type (e.g., Pending)
        if (firstType) {
          const contractorCategories = Object.keys(firstType.Contractor || {});
          const consultantCategories = Object.keys(firstType.Consultant || {});
          const allCategories = Array.from(new Set([...contractorCategories, ...consultantCategories]));
          setCategories(allCategories); // Update state with dynamic categories
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchEOTData();
  }, []);

  const renderSeparateCells = (type, category) => (
    <React.Fragment className='flex-row justify-around' key={`${type}-${category}`}>
      <td className='align-right' style={{ color: "red" }}>
        {letterdata[type]?.Consultant?.[category] || 0}
      </td>
      <td className='align-leftt' style={{ color: "green" }}>
        {letterdata[type]?.Contractor?.[category] || 0}
      </td>
    </React.Fragment>
  );

  console.log({ categories })

  return (
    <div className="invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px" style={{ margin: "10px" }}>
      <div className="flex-row justify-between">
        <h2 className="repo-heading font-weight500" style={{ padding: "0px 25px", cursor: "pointer" }} title="All">
          Letter Type
        </h2>
        <div className="flex-row">
          <th style={{ textAlign: "center", color: "red", marginRight: "10px", cursor: "pointer" }} className="flex-row">
            <div style={{ height: "10px", width: "10px", borderRadius: "50%", backgroundColor: "red", marginRight: "5px" }}></div>
            Consultant
          </th>
          <th style={{ textAlign: "center", color: "green", cursor: "pointer" }} className="flex-row">
            <div style={{ height: "10px", width: "10px", borderRadius: "50%", backgroundColor: "green", marginRight: "5px" }}></div>
            Contractor
          </th>
        </div>
      </div>
      <div className="global-table-cont scroll-container-table no-max-height" style={{ minHeight: "311px" }}>
        <table className="custom-table" style={{ minHeight: "311px" }}>
          <thead className="heading">
            <tr className="custom-table-head-tr global-table-tr">
              <th className="align-leftt font-size-text font-weightbold">Status \ Type </th>
              {categories.map((category) => (
                <th key={category} className="align-center font-size-text font-weightbold" colSpan={2}>
                  {category}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(letterdata).map((type) => (
              <tr key={type} className="custom-table-head-td global-table-td">
                <td style={{ fontWeight: "bold" }} className="align-leftt">{type}</td>
                {categories.map((category) => renderSeparateCells(type, category))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const LetterTatTable = () => {
  const [letterdata, setLetterdata] = useState({});
  const [categories, setCategories] = useState([]);
  const [isshow, SetIsshow] = useState(false);

  useEffect(() => {
    const fetchEOTData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/siteproject/letter_tat_alert/`);
        const data = response.data;
        setLetterdata(data);

        // Extract categories dynamically from the response
        const firstType = Object.values(data)[0]; // Get the first type (e.g., Pending)

        if (firstType) {
          const contractorCategories = Object.keys(firstType.Contractor || {});
          const consultantCategories = Object.keys(firstType.Consultant || {});
          const allCategories = Array.from(new Set([...contractorCategories, ...consultantCategories]));
          setCategories(allCategories); // Update state with dynamic categories
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchEOTData();
  }, []);

  const renderSeparateCells = (type, category) => (
    <React.Fragment className='flex-row justify-around' key={`${type}-${category}`}>
      <td className='align-right' style={{ color: "red" }}>
        {letterdata[type]?.Consultant?.[category] || 0}
      </td>
      <td className='align-leftt' style={{ color: "green" }}>
        {letterdata[type]?.Contractor?.[category] || 0}
      </td>
    </React.Fragment>
  );

  const showDetails = () => {
    SetIsshow(true);
  }

  const handleClose = () => {
    SetIsshow(false);
  }

  console.log({ LetterTatCategories: categories })

  return (

    <>
      {isshow && <DashboardLetterTatTypeModel handleClose={handleClose} />}

      <div div className="invoice-cont width-43vw cont-col cards-shadow2 bgwhite transaction-cont box-shadow margin-20px" style={{ margin: "10px" }
      }>
        <div className="flex-row justify-between">
          <h2 className="repo-heading font-weight500" style={{ padding: "0px 25px", cursor: "pointer" }} title="All" >
            Letter Tat
          </h2>

        </div>
        <div className="global-table-cont scroll-container-table no-max-height" style={{ minHeight: "311px", display: 'flex' }}>
          <div>
            <table className="custom-table" onClick={showDetails} style={{ minHeight: "250px", marginTop: '20px', cursor: "pointer" }}>
              <thead className="heading">
                <tr className="custom-table-head-tr global-table-tr">
                  {/* <th className="align-leftt font-size-text font-weightbold">Status \ Type </th> */}
                  {categories.map((category) => (
                    <th key={category} className="align-center font-size-text font-weightbold" >
                      {category}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.keys(letterdata).map((type) => (
                  <tr key={type} className="custom-table-tddd letter-tat global-table-td ">
                    <td style={{ fontWeight: "bold" }} className="align-leftt">{type}</td>
                    {categories.map((category) => renderSeparateCells(type, category))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div>
            <table className="custom-table tat-heading" >
              <thead className="heading">
                <tr className="custom-table-head-trr global-table-tr">
                  {letterdata?.about_to_due?.map((item, index) => (
                    <React.Fragment key={index}>
                      <th className="">{item.letter_type}</th>

                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody>

                <tr className="tat-body " onClick={showDetails} style={{ cursor: "pointer" }}>


                  {letterdata?.about_to_due?.map((item, index) => (
                    <React.Fragment key={index}>
                      <td className="">{item.letter_count}</td>

                    </React.Fragment>
                  ))}



                </tr>

                <tr className="custom-table-head-td global-table-td">


                </tr>
              </tbody>


            </table>

            <table className="custom-table" >
              <thead className="heading">
                <tr className="custom-table-head-tr global-table-tr">

                  {letterdata?.letter_due?.map((item, index) => (
                    <React.Fragment key={index}>
                      <th className="">{item.letter_type}</th>

                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody>

                <tr className="tat-body" onClick={showDetails} style={{ cursor: "pointer" }}>


                  {letterdata?.letter_due?.map((item, index) => (
                    <React.Fragment key={index}>
                      <td className="">{item.letter_count}</td>

                    </React.Fragment>
                  ))}



                </tr>

                <tr className="custom-table-head-td global-table-td" >


                </tr>
              </tbody>


            </table>
          </div>
        </div>


      </div >
    </>

  );
};





const StatsCards = () => {
  const [projectData, setProjectData] = useState(null);

  const getProjectData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/dashboard-summary-stats/`);
      setProjectData(res.data);
    } catch (err) {
      console.error('Failed to fetch project data:', err);
    }
  };

  useEffect(() => {
    getProjectData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!projectData) return <div>Loading...</div>;

  return (
    <div className="stat-cards cont-col cards-shadow2 bgwhite transaction-cont box-shadow" style={{ margin: "10px 20px" }}>
      {/* Total Projects Work type Card */}
      <div className="stat-card">
        <div className="stat-value"><ProjectByWorkTypeModel project_number={projectData.total_project_work_type['ae/ie'] + projectData.total_project_work_type['o&m'] + projectData.total_project_work_type.safety + projectData.total_project_work_type.dpr} work_type="null" /></div>
        <div className="stat-label">Total Projects</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">AE/IE</span>
            <span className="detail-count" style={{ color: 'green' }}>
              {/* {projectData.total_projects_by_role.Active} */}

              {/* <ProjectByOurRoleModel project_number={projectData.total_project_work_type['ae/ie']} our_role="active" /> */}
              <ProjectByWorkTypeModel project_number={projectData.total_project_work_type['ae/ie']} work_type="construction consultant" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">O&M</span>
            <span className="detail-count" style={{ color: 'orange' }}>
              {/* <ProjectByOurRoleModel project_number={projectData.total_project_work_type['o&m']} our_role="partially" /> */}
              <ProjectByWorkTypeModel project_number={projectData.total_project_work_type['o&m']} work_type="operations & maintenance consultant" />
            </span>
          </div>

          <div className="detail-item">
            <span className="detail-label">Safety</span>
            <span className="detail-count" style={{ color: 'red' }}>
              {/* {projectData.total_projects_by_role.Silent} */}
              {/* <ProjectByOurRoleModel project_number={projectData.total_project_work_type.safety} our_role="silent" /> */}
              <ProjectByWorkTypeModel project_number={projectData.total_project_work_type?.safety} work_type="safety consultant" />
            </span>
          </div>

          <div className="detail-item">
            <span className="detail-label">DPR</span>
            <span className="detail-count" style={{ color: 'green' }}>
              {/* {projectData.total_projects_by_role.Active} */}
              {/* <ProjectByOurRoleModel project_number={projectData.total_project_work_type.dpr} our_role="active" /> */}
              <ProjectByWorkTypeModel project_number={projectData.total_project_work_type?.dpr} work_type="dpr" />
            </span>
          </div>

        </div>
      </div>


      {/* Total Projects Card */}
      <div className="stat-card">
        <div className="stat-value"><ProjectByOurRoleModel project_number={projectData.total_projects_by_role?.Active + projectData.total_projects_by_role?.Partially + projectData.total_projects_by_role?.Silent} our_role="null" /></div>
        <div className="stat-label">Supervision</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">Active</span>
            <span className="detail-count" style={{ color: 'green' }}>
              {/* {projectData.total_projects_by_role.Active} */}
              {/* <ProjectByOurRoleModel project_number={projectData.total_projects_by_role.Active} our_role="active" /> */}
              <ProjectByOurRoleModel project_number={projectData.total_projects_by_role?.Active} our_role="active" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Partially</span>
            <span className="detail-count" style={{ color: 'orange' }}>
              {/* <ProjectByOurRoleModel project_number={projectData.total_projects_by_role.Partially} our_role="partially" /> */}
              <ProjectByOurRoleModel project_number={projectData.total_projects_by_role?.Partially} our_role="partially" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Silent</span>
            <span className="detail-count" style={{ color: 'red' }}>
              {/* {projectData.total_projects_by_role.Silent} */}
              {/* <ProjectByOurRoleModel project_number={projectData.total_projects_by_role.Silent} our_role="silent" /> */}
              <ProjectByOurRoleModel project_number={projectData.total_projects_by_role?.Silent} our_role="silent" />
            </span>
          </div>



        </div>
      </div>


      {/* Total Employees Card
       <div className="stat-card">
        <div className="stat-value"><EmployeebyTypeModel count={projectData.total_employees} professional_type="null"/> </div>
        <div className="stat-label">Total Employees</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">Key Prof</span>
            <span className="detail-count" style={{ color: 'green' }}>


              <EmployeebyTypeModel count= {projectData.employees_by_professional_type.KP} professional_type="Key Professional"/>

            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Sub Prof</span>
            <span className="detail-count" style={{ color: 'orange' }}>


              <EmployeebyTypeModel count= {projectData.employees_by_professional_type.SP} professional_type="Sub Professional"/>

            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Sup Staff</span>
            <span className="detail-count" style={{ color: 'red' }}>


              <EmployeebyTypeModel count=  {projectData.employees_by_professional_type.SS} professional_type="Support Staff"/>


            </span>
          </div>
        </div>
      </div> */}

      {/* Total Vacant Positions Card */}
      <div className="stat-card">
        <div className="stat-value"> <VacantEmployeebyTypeModel count={projectData.total_vacant} professional_type="null" />
        </div>
        <div className="stat-label">Total Vacant</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">Key Prof</span>
            <span className="detail-count" style={{ color: 'green' }}>
              <VacantEmployeebyTypeModel count={projectData.vacant_designations_count.KP / 2} professional_type="Key Professional" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Sub Prof</span>
            <span className="detail-count" style={{ color: 'orange' }}>
              <VacantEmployeebyTypeModel count={projectData.vacant_designations_count.SP / 2} professional_type="Sub Professional" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Sup Staff</span>
            <span className="detail-count" style={{ color: 'red' }}>
              <VacantEmployeebyTypeModel count={projectData.vacant_designations_count.SS / 2} professional_type="Support Staff" />
            </span>
          </div>
        </div>
      </div>

      {/* Invoice Card */}
      {/* <div className="stat-card">
        <div className="stat-value">{projectData.invoices}</div>
        <div className="stat-label">Invoice</div>
        <div className="stat-details">

        </div>
      </div> */}


      {/* <div className="stat-card">
        <div className="stat-value">
          148.81 Cr.
          </div>
        <div className="stat-label">BOQ Amount</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">Invoice</span>

            <span className="detail-count" style={{ color: 'green' }}>
              0.44 Cr.

            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Payment Rec</span>

            <span className="detail-count" style={{ color: 'orange' }}>
          0.21 Cr.
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Pending</span>
            <span className="detail-count" style={{ color: 'red' }}>
          148.37 Cr. 
            </span>
          </div>
        </div>
      </div> */}

      {/* Letter Pendency Card */}
      <div className="stat-card">
        <div className="stat-value">
          <LetterbyStatusModel count={projectData.letter_pendencies.Pnd + projectData.letter_pendencies.Inprs + projectData.letter_pendencies.PrtyClose} letter_status="null" />
        </div>
        <div className="stat-label">Letter Pendency</div>
        <div className="stat-details">
          <div className="detail-item">
            <span className="detail-label">Pend</span>
            <span className="detail-count" style={{ color: 'green' }}>
              <LetterbyStatusModel count={projectData.letter_pendencies.Pnd} letter_status="pending" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">In prs</span>
            <span className="detail-count" style={{ color: 'orange' }}>
              <LetterbyStatusModel count={projectData.letter_pendencies.Inprs} letter_status="in-progress" />
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">PrtyClose</span>
            <span className="detail-count" style={{ color: 'red' }}>
              <LetterbyStatusModel count={projectData.letter_pendencies.PrtyClose} letter_status="partially-close" />
            </span>
          </div>
        </div>
      </div>

      {/* Pending Salary Card */}
      {/* <div className="stat-card">
        <div className="stat-value">{projectData.pending_salary}</div>
        <div className="stat-label">Pending Salary</div>
        <div className="stat-details">

        </div>
      </div> */}
    </div>
  );
};





// const theme = createTheme({
//   palette: {
//     mode: 'light',
//     primary: { main: '#3B82F6', light: '#60A5FA', dark: '#2563EB' },
//     secondary: { main: '#10B981', light: '#34D399', dark: '#059669' },
//     warning: { main: '#F59E0B', light: '#FBBF24', dark: '#D97706' },
//     error: { main: '#EF4444', light: '#F87171', dark: '#DC2626' },
//     info: { main: '#8B5CF6', light: '#A78BFA', dark: '#7C3AED' },
//     background: { default: '#F3F4F6', paper: '#FFFFFF' }
//   },
//   shape: { borderRadius: 16 },
//   typography: {
//     fontFamily: '"Inter", "Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
//     h4: { fontWeight: 700, fontSize: '1.8rem' },
//     h5: { fontWeight: 600, fontSize: '1.4rem' },
//     h6: { fontWeight: 600, fontSize: '1.2rem' },
//     body1: { fontSize: '0.95rem' },
//     body2: { fontSize: '0.875rem' }
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 20,
//           boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
//           transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//           '&:hover': {
//             transform: 'translateY(-4px)',
//             boxShadow: '0 12px 48px rgba(0,0,0,0.12)'
//           }
//         }
//       }
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           textTransform: 'none',
//           fontWeight: 600,
//           padding: '8px 20px',
//           transition: 'all 0.3s ease'
//         },
//         contained: {
//           boxShadow: 'none',
//           '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
//         }
//       }
//     }
//   }
// });

// const AdminDashboardDetails = () => {
//   const [selectedProject, setSelectedProject] = useState('project1');
//   const [tabValue, setTabValue] = useState(0);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Dialog states
//   const [openContractorDialog, setOpenContractorDialog] = useState(false);
//   const [openEOTDialog, setOpenEOTDialog] = useState(false);
//   const [openCOSDialog, setOpenCOSDialog] = useState(false);
//   const [openBillingDialog, setOpenBillingDialog] = useState(false);
//   const [openProgressDialog, setOpenProgressDialog] = useState(false);
//   const [selectedContractorForProgress, setSelectedContractorForProgress] = useState(null);

//   // Form states
//   const [newContractor, setNewContractor] = useState({ name: '', cost: '', time: '' });
//   const [newEOT, setNewEOT] = useState({ contractor: '', requestedDays: '', reason: '' });
//   const [newCOS, setNewCOS] = useState({ contractor: '', requestedAmount: '', description: '' });
//   const [newBilling, setNewBilling] = useState({ contractor: '', month: '', raisedAmount: '' });

//   // Projects Data
//   const projects = [
//     { id: 'project1', name: '🚇 Metro Rail Phase-2', budget: '245.8M', progress: 68, location: 'Mumbai', client: 'MMRDA', startDate: '2024-01-01', endDate: '2026-12-31' },
//     { id: 'project2', name: '🏗️ Coastal Highway', budget: '180.5M', progress: 42, location: 'Delhi', client: 'NHAI', startDate: '2024-03-01', endDate: '2027-06-30' },
//     { id: 'project3', name: '🏢 Smart Tower Complex', budget: '95.3M', progress: 75, location: 'Bangalore', client: 'SmartCity Corp', startDate: '2024-02-01', endDate: '2025-12-31' },
//     { id: 'project4', name: '🌉 Bridge Connect', budget: '62.7M', progress: 35, location: 'Chennai', client: 'Highways Dept', startDate: '2024-04-01', endDate: '2026-09-30' },
//   ];

//   // Contractors with detailed information
//   const [contractors, setContractors] = useState([
//     {
//       id: 1,
//       name: 'ABC Constructions',
//       contractCost: 12500000,
//       remainingCost: 5000000,
//       completionTime: 420,
//       remainingTime: 142,
//       efficiency: 92,
//       pendingInvoices: 3,
//       status: 'active',
//       color: '#3B82F6'
//     },
//     {
//       id: 2,
//       name: 'XYZ Builders',
//       contractCost: 8750000,
//       remainingCost: 4200000,
//       completionTime: 365,
//       remainingTime: 210,
//       efficiency: 78,
//       pendingInvoices: 5,
//       status: 'active',
//       color: '#10B981'
//     },
//     {
//       id: 3,
//       name: 'PQR Infra',
//       contractCost: 6520000,
//       remainingCost: 1800000,
//       completionTime: 300,
//       remainingTime: 65,
//       efficiency: 88,
//       pendingInvoices: 2,
//       status: 'active',
//       color: '#F59E0B'
//     },
//     {
//       id: 4,
//       name: 'LMN Developers',
//       contractCost: 9400000,
//       remainingCost: 6500000,
//       completionTime: 450,
//       remainingTime: 320,
//       efficiency: 65,
//       pendingInvoices: 4,
//       status: 'active',
//       color: '#EF4444'
//     },
//   ]);

//   // Billing Data - Monthly billing records
//   const [billingData, setBillingData] = useState([
//     { id: 1, contractor: 'ABC Constructions', month: 'Oct 2024', raised: 850000, aeApproved: 820000, clientApproved: 810000, status: 'approved' },
//     { id: 2, contractor: 'ABC Constructions', month: 'Nov 2024', raised: 920000, aeApproved: 890000, clientApproved: 880000, status: 'approved' },
//     { id: 3, contractor: 'XYZ Builders', month: 'Oct 2024', raised: 680000, aeApproved: 650000, clientApproved: 640000, status: 'approved' },
//     { id: 4, contractor: 'XYZ Builders', month: 'Nov 2024', raised: 720000, aeApproved: 680000, clientApproved: 0, status: 'pending' },
//     { id: 5, contractor: 'PQR Infra', month: 'Oct 2024', raised: 550000, aeApproved: 550000, clientApproved: 540000, status: 'approved' },
//     { id: 6, contractor: 'LMN Developers', month: 'Nov 2024', raised: 480000, aeApproved: 450000, clientApproved: 0, status: 'with_ae' },
//   ]);

//   // EOT Data - Extension of Time requests
//   const [eotData, setEotData] = useState([
//     { id: 1, contractor: 'ABC Constructions', requestedDays: 45, aeApprovedDays: 30, clientApprovedDays: 30, status: 'approved', reason: 'Weather delays - heavy monsoons', date: '2024-11-15' },
//     { id: 2, contractor: 'XYZ Builders', requestedDays: 60, aeApprovedDays: 0, clientApprovedDays: 0, status: 'with_ae', reason: 'Material shortage - steel supply chain', date: '2024-12-01' },
//     { id: 3, contractor: 'PQR Infra', requestedDays: 25, aeApprovedDays: 20, clientApprovedDays: 20, status: 'approved', reason: 'Design change request from client', date: '2024-11-20' },
//     { id: 4, contractor: 'LMN Developers', requestedDays: 35, aeApprovedDays: 25, clientApprovedDays: 0, status: 'with_client', reason: 'Foundation issues', date: '2024-12-05' },
//   ]);

//   // COS Data - Change of Scope requests
//   const [cosData, setCosData] = useState([
//     { id: 1, contractor: 'ABC Constructions', requestedAmount: 450000, aeApprovedAmount: 420000, clientApprovedAmount: 420000, status: 'approved', description: 'Additional steel reinforcement', date: '2024-11-10' },
//     { id: 2, contractor: 'XYZ Builders', requestedAmount: 280000, aeApprovedAmount: 250000, clientApprovedAmount: 0, status: 'with_client', description: 'Extra excavation work', date: '2024-11-25' },
//     { id: 3, contractor: 'PQR Infra', requestedAmount: 180000, aeApprovedAmount: 0, clientApprovedAmount: 0, status: 'rejected', description: 'Premium material upgrade', date: '2024-12-01' },
//     { id: 4, contractor: 'LMN Developers', requestedAmount: 320000, aeApprovedAmount: 300000, clientApprovedAmount: 0, status: 'with_ae', description: 'Additional plumbing work', date: '2024-12-08' },
//   ]);

//   // Site Progress Data
//   const [siteProgress, setSiteProgress] = useState([
//     { contractor: 'ABC Constructions', physicalProgress: 68, financialProgress: 65, clientApproved: 67, qualityScore: 85, safetyScore: 92 },
//     { contractor: 'XYZ Builders', physicalProgress: 42, financialProgress: 40, clientApproved: 41, qualityScore: 72, safetyScore: 78 },
//     { contractor: 'PQR Infra', physicalProgress: 80, financialProgress: 75, clientApproved: 78, qualityScore: 90, safetyScore: 88 },
//     { contractor: 'LMN Developers', physicalProgress: 30, financialProgress: 28, clientApproved: 29, qualityScore: 68, safetyScore: 75 },
//   ]);

//   // Milestones
//   const [milestones, setMilestones] = useState([
//     { id: 1, name: 'Site Clearance', targetDate: '2024-02-15', actualDate: '2024-02-10', status: 'completed', progress: 100, description: 'Land clearing and preparation' },
//     { id: 2, name: 'Foundation Work', targetDate: '2024-04-30', actualDate: '2024-05-15', status: 'completed', progress: 100, description: 'Base concrete and reinforcement' },
//     { id: 3, name: 'Structural Framework', targetDate: '2024-08-31', actualDate: null, status: 'in_progress', progress: 75, description: 'Columns and beams installation' },
//     { id: 4, name: 'Floor Slabs', targetDate: '2024-12-31', actualDate: null, status: 'in_progress', progress: 45, description: 'Floor casting for all levels' },
//     { id: 5, name: 'Roof Work', targetDate: '2025-03-31', actualDate: null, status: 'pending', progress: 15, description: 'Roof structure and waterproofing' },
//     { id: 6, name: 'Finishing', targetDate: '2025-06-30', actualDate: null, status: 'pending', progress: 5, description: 'Interior and exterior finishing' },
//   ]);

//   // Helper Functions
//   const getContractorById = (id) => contractors.find(c => c.id === id);
//   const getMonthlyBillingSummary = () => {
//     const months = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb'];
//     return months.map(month => ({
//       month,
//       raised: billingData.filter(b => b.month.includes(month)).reduce((sum, b) => sum + b.raised, 0) / 100000,
//       approved: billingData.filter(b => b.month.includes(month) && b.clientApproved > 0).reduce((sum, b) => sum + b.clientApproved, 0) / 100000,
//     }));
//   };

//   // Handlers
//   const handleAddContractor = () => {
//     const newId = contractors.length + 1;
//     setContractors([...contractors, {
//       id: newId,
//       name: newContractor.name,
//       contractCost: parseFloat(newContractor.cost) * 100000,
//       remainingCost: parseFloat(newContractor.cost) * 100000,
//       completionTime: parseInt(newContractor.time) * 30,
//       remainingTime: parseInt(newContractor.time) * 30,
//       efficiency: 75,
//       pendingInvoices: 0,
//       status: 'active',
//       color: `hsl(${Math.random() * 360}, 70%, 50%)`
//     }]);
//     setOpenContractorDialog(false);
//     setNewContractor({ name: '', cost: '', time: '' });
//     setSnackbar({ open: true, message: 'Contractor added successfully!', severity: 'success' });
//   };

//   const handleAddEOT = () => {
//     const newId = eotData.length + 1;
//     setEotData([...eotData, {
//       id: newId,
//       contractor: newEOT.contractor,
//       requestedDays: parseInt(newEOT.requestedDays),
//       aeApprovedDays: 0,
//       clientApprovedDays: 0,
//       status: 'with_ae',
//       reason: newEOT.reason,
//       date: new Date().toISOString().split('T')[0]
//     }]);
//     setOpenEOTDialog(false);
//     setNewEOT({ contractor: '', requestedDays: '', reason: '' });
//     setSnackbar({ open: true, message: 'EOT request submitted to AE!', severity: 'success' });
//   };

//   const handleAddCOS = () => {
//     const newId = cosData.length + 1;
//     setCosData([...cosData, {
//       id: newId,
//       contractor: newCOS.contractor,
//       requestedAmount: parseFloat(newCOS.requestedAmount),
//       aeApprovedAmount: 0,
//       clientApprovedAmount: 0,
//       status: 'with_ae',
//       description: newCOS.description,
//       date: new Date().toISOString().split('T')[0]
//     }]);
//     setOpenCOSDialog(false);
//     setNewCOS({ contractor: '', requestedAmount: '', description: '' });
//     setSnackbar({ open: true, message: 'COS request submitted to AE!', severity: 'success' });
//   };

//   const handleAddBilling = () => {
//     const newId = billingData.length + 1;
//     setBillingData([...billingData, {
//       id: newId,
//       contractor: newBilling.contractor,
//       month: newBilling.month,
//       raised: parseFloat(newBilling.raisedAmount),
//       aeApproved: 0,
//       clientApproved: 0,
//       status: 'with_ae'
//     }]);
//     setOpenBillingDialog(false);
//     setNewBilling({ contractor: '', month: '', raisedAmount: '' });
//     setSnackbar({ open: true, message: 'Billing entry added! Pending AE approval.', severity: 'success' });
//   };

//   const handleAEApprove = (type, id, approvedValue) => {
//     if (type === 'eot') {
//       setEotData(eotData.map(item =>
//         item.id === id ? { ...item, aeApprovedDays: approvedValue, status: 'with_client' } : item
//       ));
//     } else if (type === 'cos') {
//       setCosData(cosData.map(item =>
//         item.id === id ? { ...item, aeApprovedAmount: approvedValue, status: 'with_client' } : item
//       ));
//     } else if (type === 'billing') {
//       setBillingData(billingData.map(item =>
//         item.id === id ? { ...item, aeApproved: approvedValue, status: 'with_client' } : item
//       ));
//     }
//     setSnackbar({ open: true, message: 'AE approved! Waiting for client approval.', severity: 'success' });
//   };

//   const handleClientApprove = (type, id) => {
//     if (type === 'eot') {
//       const eot = eotData.find(item => item.id === id);
//       setEotData(eotData.map(item =>
//         item.id === id ? { ...item, clientApprovedDays: item.aeApprovedDays, status: 'approved' } : item
//       ));
//       // Update contractor's remaining time
//       setContractors(contractors.map(c =>
//         c.name === eot.contractor ? { ...c, remainingTime: c.remainingTime + eot.aeApprovedDays, completionTime: c.completionTime + eot.aeApprovedDays } : c
//       ));
//     } else if (type === 'cos') {
//       const cos = cosData.find(item => item.id === id);
//       setCosData(cosData.map(item =>
//         item.id === id ? { ...item, clientApprovedAmount: item.aeApprovedAmount, status: 'approved' } : item
//       ));
//       // Update contractor's contract cost
//       setContractors(contractors.map(c =>
//         c.name === cos.contractor ? { ...c, contractCost: c.contractCost + cos.aeApprovedAmount, remainingCost: c.remainingCost + cos.aeApprovedAmount } : c
//       ));
//     } else if (type === 'billing') {
//       const billing = billingData.find(item => item.id === id);
//       setBillingData(billingData.map(item =>
//         item.id === id ? { ...item, clientApproved: item.aeApproved, status: 'approved' } : item
//       ));
//       // Update contractor's remaining cost
//       setContractors(contractors.map(c =>
//         c.name === billing.contractor ? { ...c, remainingCost: c.remainingCost - billing.aeApproved } : c
//       ));
//     }
//     setSnackbar({ open: true, message: 'Client approved successfully!', severity: 'success' });
//   };

//   const handleUpdateProgress = () => {
//     setSiteProgress(siteProgress.map(p =>
//       p.contractor === selectedContractorForProgress.contractor
//         ? { ...p, physicalProgress: selectedContractorForProgress.physical, financialProgress: selectedContractorForProgress.financial }
//         : p
//     ));
//     setOpenProgressDialog(false);
//     setSnackbar({ open: true, message: 'Progress updated successfully!', severity: 'success' });
//   };

//   // Stats Cards Component
//   const StatCard = ({ title, value, icon, trend, trendValue, subtext, color }) => (
//     <Card sx={{ background: `linear-gradient(135deg, ${color} 0%, ${color}cc 100%)`, color: 'white' }}>
//       <CardContent>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Box>
//             <Typography variant="body2" sx={{ opacity: 0.9, fontWeight: 500 }}>{title}</Typography>
//             <Typography variant="h3" sx={{ fontWeight: 'bold', mt: 1, fontSize: '2rem' }}>{value}</Typography>
//             {trend && (
//               <Box display="flex" alignItems="center" mt={1}>
//                 {trend === 'up' ? <TrendingUpIcon sx={{ fontSize: 16 }} /> : <TrendingDownIcon sx={{ fontSize: 16 }} />}
//                 <Typography variant="caption" sx={{ ml: 0.5 }}>{trendValue}</Typography>
//               </Box>
//             )}
//             {subtext && (
//               <Typography variant="caption" sx={{ opacity: 0.8, mt: 0.5, display: 'block' }}>
//                 {subtext}
//               </Typography>
//             )}
//           </Box>
//           <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 56, height: 56 }}>
//             {icon}
//           </Avatar>
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ bgcolor: '#F3F4F6', minHeight: '100vh', p: 3 }}>
//         {/* Header */}
//         <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
//           <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
//             <Box>
//               <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
//                 🏗️ Project Management Dashboard
//               </Typography>
//               <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                 Real-time contractor tracking, billing management & progress monitoring
//               </Typography>
//             </Box>
//             <Box display="flex" gap={2} alignItems="center" mt={{ xs: 2, md: 0 }}>
//               <FormControl size="small" sx={{ minWidth: 250, bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 2 }}>
//                 <Select value={selectedProject} onChange={(e) => setSelectedProject(e.target.value)} sx={{ color: 'white' }}>
//                   {projects.map(project => (
//                     <MenuItem key={project.id} value={project.id}>
//                       <Box display="flex" justifyContent="space-between" width="100%">
//                         <span>{project.name}</span>
//                         <Chip size="small" label={`${project.progress}%`} />
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//               <Tooltip title="Refresh Data">
//                 <IconButton sx={{ color: 'white', bgcolor: 'rgba(255,255,255,0.15)' }}>
//                   <RefreshIcon />
//                 </IconButton>
//               </Tooltip>
//             </Box>
//           </Box>
//         </Paper>

//         {/* Stats Grid */}
//         <Grid container spacing={3} sx={{ mb: 4 }}>
//           <Grid item xs={12} sm={6} md={3}>
//             <StatCard title="Active Projects" value="12" icon={<DashboardIcon />} trend="up" trendValue="+2" subtext="4 in progress, 8 completed" color="#3B82F6" />
//           </Grid>
//           <Grid item xs={12} sm={6} md={3}>
//             <StatCard title="Active Contractors" value={contractors.length.toString()} icon={<PeopleIcon />} trend="up" trendValue="+1" subtext="Avg efficiency: 81%" color="#10B981" />
//           </Grid>
//           <Grid item xs={12} sm={6} md={3}>
//             <StatCard title="Pending Approvals" value={eotData.filter(e => e.status !== 'approved').length + cosData.filter(c => c.status !== 'approved').length + billingData.filter(b => b.status !== 'approved').length} icon={<PendingIcon />} trend="down" trendValue="-3" subtext="AE: 4 | Client: 6" color="#F59E0B" />
//           </Grid>
//           <Grid item xs={12} sm={6} md={3}>
//             <StatCard title="Overall Progress" value="67%" icon={<CheckCircleIcon />} trend="up" trendValue="+5%" subtext="On track for Q2 target" color="#8B5CF6" />
//           </Grid>
//         </Grid>

//         {/* Action Buttons */}
//         <Box display="flex" gap={2} mb={4} flexWrap="wrap">
//           <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setOpenContractorDialog(true)}>Add Contractor</Button>
//           <Button variant="contained" color="secondary" startIcon={<ScheduleIcon />} onClick={() => setOpenEOTDialog(true)}>Request EOT</Button>
//           <Button variant="contained" sx={{ bgcolor: '#F59E0B', '&:hover': { bgcolor: '#D97706' } }} startIcon={<BuildIcon />} onClick={() => setOpenCOSDialog(true)}>Request COS</Button>
//           <Button variant="contained" sx={{ bgcolor: '#8B5CF6', '&:hover': { bgcolor: '#7C3AED' } }} startIcon={<AttachMoneyIcon />} onClick={() => setOpenBillingDialog(true)}>Raise Bill</Button>
//         </Box>

//         {/* Tabs Section */}
//         <Paper sx={{ mb: 4, borderRadius: 3 }}>
//           <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
//             <Tab label="📊 Overview" />
//             <Tab label="👷 Contractors" />
//             <Tab label="💰 Billing" />
//             <Tab label="⏰ EOT & COS" />
//             <Tab label="📈 Progress & Milestones" />
//           </Tabs>

//           {/* Tab 0: Overview */}
//           {tabValue === 0 && (
//             <Box sx={{ p: 3 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={8}>
//                   <Card>
//                     <CardContent>
//                       <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>📊 Monthly Billing Overview (₹ Lakhs)</Typography>
//                       <ResponsiveContainer width="100%" height={350}>
//                         <BarChart data={getMonthlyBillingSummary()}>
//                           <CartesianGrid strokeDasharray="3 3" />
//                           <XAxis dataKey="month" />
//                           <YAxis />
//                           <ReTooltip />
//                           <Legend />
//                           <Bar dataKey="raised" fill="#3B82F6" name="Amount Raised" radius={[8, 8, 0, 0]} />
//                           <Bar dataKey="approved" fill="#10B981" name="Client Approved" radius={[8, 8, 0, 0]} />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//                 <Grid item xs={12} md={4}>
//                   <Card sx={{ height: '100%' }}>
//                     <CardContent>
//                       <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>🎯 Contractor Progress</Typography>
//                       <ResponsiveContainer width="100%" height={300}>
//                         <PieChart>
//                           <Pie data={contractors.map(c => ({ name: c.name, value: (1 - c.remainingCost / c.contractCost) * 100, color: c.color }))} cx="50%" cy="50%" innerRadius={60} outerRadius={100} paddingAngle={5} dataKey="value" label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}>
//                             {contractors.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)}
//                           </Pie>
//                           <ReTooltip />
//                         </PieChart>
//                       </ResponsiveContainer>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}

//           {/* Tab 1: Contractors Table */}
//           {tabValue === 1 && (
//             <Box sx={{ p: 3 }}>
//               <TableContainer component={Paper} elevation={0}>
//                 <Table>
//                   <TableHead sx={{ bgcolor: '#F9FAFB' }}>
//                     <TableRow>
//                       <TableCell><strong>Contractor</strong></TableCell>
//                       <TableCell><strong>Contract Cost (₹)</strong></TableCell>
//                       <TableCell><strong>Remaining (₹)</strong></TableCell>
//                       <TableCell><strong>Completion Time</strong></TableCell>
//                       <TableCell><strong>Efficiency</strong></TableCell>
//                       <TableCell><strong>Progress</strong></TableCell>
//                       <TableCell><strong>Actions</strong></TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {contractors.map((contractor) => (
//                       <TableRow key={contractor.id} hover>
//                         <TableCell>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <Avatar sx={{ width: 32, height: 32, bgcolor: contractor.color }}>{contractor.name.charAt(0)}</Avatar>
//                             <Typography fontWeight={500}>{contractor.name}</Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell>₹{(contractor.contractCost / 100000).toFixed(1)}L</TableCell>
//                         <TableCell>₹{(contractor.remainingCost / 100000).toFixed(1)}L</TableCell>
//                         <TableCell>{contractor.completionTime} days</TableCell>
//                         <TableCell>
//                           <Chip label={`${contractor.efficiency}%`} size="small" sx={{ bgcolor: contractor.efficiency > 85 ? '#10B981' : contractor.efficiency > 70 ? '#F59E0B' : '#EF4444', color: 'white' }} />
//                         </TableCell>
//                         <TableCell>
//                           <Box display="flex" alignItems="center" gap={1}>
//                             <LinearProgress variant="determinate" value={(1 - contractor.remainingCost / contractor.contractCost) * 100} sx={{ width: 100, height: 8, borderRadius: 2 }} />
//                             <Typography variant="body2">{(1 - contractor.remainingCost / contractor.contractCost) * 100}%</Typography>
//                           </Box>
//                         </TableCell>
//                         <TableCell>
//                           <Tooltip title="Update Progress">
//                             <IconButton size="small" onClick={() => {
//                               const progress = siteProgress.find(p => p.contractor === contractor.name);
//                               setSelectedContractorForProgress({ contractor: contractor.name, physical: progress?.physicalProgress || 0, financial: progress?.financialProgress || 0 });
//                               setOpenProgressDialog(true);
//                             }}>
//                               <EditIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>
//           )}

//           {/* Tab 2: Billing */}
//           {tabValue === 2 && (
//             <Box sx={{ p: 3 }}>
//               <TableContainer component={Paper} elevation={0}>
//                 <Table>
//                   <TableHead sx={{ bgcolor: '#F9FAFB' }}>
//                     <TableRow>
//                       <TableCell><strong>Contractor</strong></TableCell>
//                       <TableCell><strong>Month</strong></TableCell>
//                       <TableCell><strong>Raised (₹)</strong></TableCell>
//                       <TableCell><strong>AE Approved</strong></TableCell>
//                       <TableCell><strong>Client Approved</strong></TableCell>
//                       <TableCell><strong>Status</strong></TableCell>
//                       <TableCell><strong>Actions</strong></TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {billingData.map((bill) => (
//                       <TableRow key={bill.id} hover>
//                         <TableCell>{bill.contractor}</TableCell>
//                         <TableCell>{bill.month}</TableCell>
//                         <TableCell>₹{(bill.raised / 100000).toFixed(1)}L</TableCell>
//                         <TableCell>{bill.aeApproved ? `₹${(bill.aeApproved / 100000).toFixed(1)}L` : '-'}</TableCell>
//                         <TableCell>{bill.clientApproved ? `₹${(bill.clientApproved / 100000).toFixed(1)}L` : '-'}</TableCell>
//                         <TableCell>
//                           <Chip label={bill.status === 'approved' ? 'Approved' : bill.status === 'with_ae' ? 'With AE' : 'With Client'} size="small" sx={{ bgcolor: bill.status === 'approved' ? '#10B981' : bill.status === 'with_ae' ? '#F59E0B' : '#3B82F6', color: 'white' }} />
//                         </TableCell>
//                         <TableCell>
//                           {bill.status === 'with_ae' && (
//                             <Button size="small" variant="outlined" onClick={() => {
//                               const approved = prompt('Enter AE approved amount (₹):', bill.raised);
//                               if (approved) handleAEApprove('billing', bill.id, parseFloat(approved));
//                             }}>AE Approve</Button>
//                           )}
//                           {bill.status === 'with_client' && (
//                             <Button size="small" variant="contained" color="primary" onClick={() => handleClientApprove('billing', bill.id)}>Client Approve</Button>
//                           )}
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Box>
//           )}

//           {/* Tab 3: EOT & COS */}
//           {tabValue === 3 && (
//             <Box sx={{ p: 3 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>⏰ EOT Requests</Typography>
//                   <TableContainer component={Paper} elevation={0}>
//                     <Table size="small">
//                       <TableHead sx={{ bgcolor: '#F9FAFB' }}>
//                         <TableRow>
//                           <TableCell><strong>Contractor</strong></TableCell>
//                           <TableCell><strong>Requested</strong></TableCell>
//                           <TableCell><strong>AE Approved</strong></TableCell>
//                           <TableCell><strong>Status</strong></TableCell>
//                           <TableCell><strong>Actions</strong></TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {eotData.map((eot) => (
//                           <TableRow key={eot.id}>
//                             <TableCell>{eot.contractor}</TableCell>
//                             <TableCell>{eot.requestedDays} days</TableCell>
//                             <TableCell>{eot.aeApprovedDays || '-'} days</TableCell>
//                             <TableCell>
//                               <Chip label={eot.status === 'approved' ? 'Approved' : eot.status === 'with_ae' ? 'With AE' : 'With Client'} size="small" sx={{ bgcolor: eot.status === 'approved' ? '#10B981' : eot.status === 'with_ae' ? '#F59E0B' : '#3B82F6', color: 'white' }} />
//                             </TableCell>
//                             <TableCell>
//                               {eot.status === 'with_ae' && (
//                                 <Button size="small" variant="outlined" onClick={() => {
//                                   const approved = prompt('Enter AE approved days:', eot.requestedDays);
//                                   if (approved) handleAEApprove('eot', eot.id, parseInt(approved));
//                                 }}>AE Approve</Button>
//                               )}
//                               {eot.status === 'with_client' && (
//                                 <Button size="small" variant="contained" color="primary" onClick={() => handleClientApprove('eot', eot.id)}>Client Approve</Button>
//                               )}
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Grid>
//                 <Grid item xs={12} md={6}>
//                   <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>💰 COS Requests</Typography>
//                   <TableContainer component={Paper} elevation={0}>
//                     <Table size="small">
//                       <TableHead sx={{ bgcolor: '#F9FAFB' }}>
//                         <TableRow>
//                           <TableCell><strong>Contractor</strong></TableCell>
//                           <TableCell><strong>Requested</strong></TableCell>
//                           <TableCell><strong>AE Approved</strong></TableCell>
//                           <TableCell><strong>Status</strong></TableCell>
//                           <TableCell><strong>Actions</strong></TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {cosData.map((cos) => (
//                           <TableRow key={cos.id}>
//                             <TableCell>{cos.contractor}</TableCell>
//                             <TableCell>₹{(cos.requestedAmount / 100000).toFixed(1)}L</TableCell>
//                             <TableCell>{cos.aeApprovedAmount ? `₹${(cos.aeApprovedAmount / 100000).toFixed(1)}L` : '-'}</TableCell>
//                             <TableCell>
//                               <Chip label={cos.status === 'approved' ? 'Approved' : cos.status === 'with_ae' ? 'With AE' : 'With Client'} size="small" sx={{ bgcolor: cos.status === 'approved' ? '#10B981' : cos.status === 'with_ae' ? '#F59E0B' : '#3B82F6', color: 'white' }} />
//                             </TableCell>
//                             <TableCell>
//                               {cos.status === 'with_ae' && (
//                                 <Button size="small" variant="outlined" onClick={() => {
//                                   const approved = prompt('Enter AE approved amount (₹):', cos.requestedAmount);
//                                   if (approved) handleAEApprove('cos', cos.id, parseFloat(approved));
//                                 }}>AE Approve</Button>
//                               )}
//                               {cos.status === 'with_client' && (
//                                 <Button size="small" variant="contained" color="primary" onClick={() => handleClientApprove('cos', cos.id)}>Client Approve</Button>
//                               )}
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}

//           {/* Tab 4: Progress & Milestones */}
//           {tabValue === 4 && (
//             <Box sx={{ p: 3 }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12}>
//                   <Card>
//                     <CardContent>
//                       <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>📈 Site Progress Overview</Typography>
//                       <ResponsiveContainer width="100%" height={400}>
//                         <ComposedChart data={siteProgress}>
//                           <CartesianGrid strokeDasharray="3 3" />
//                           <XAxis dataKey="contractor" />
//                           <YAxis />
//                           <ReTooltip />
//                           <Legend />
//                           <Bar dataKey="physicalProgress" fill="#3B82F6" name="Physical Progress %" radius={[8, 8, 0, 0]} />
//                           <Bar dataKey="clientApproved" fill="#10B981" name="Client Approved %" radius={[8, 8, 0, 0]} />
//                           <Line type="monotone" dataKey="qualityScore" stroke="#F59E0B" name="Quality Score" strokeWidth={3} />
//                         </ComposedChart>
//                       </ResponsiveContainer>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Card>
//                     <CardContent>
//                       <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>🎯 Project Milestones</Typography>
//                       <Stepper orientation="vertical" activeStep={milestones.filter(m => m.status === 'completed').length - 1}>
//                         {milestones.map((milestone) => (
//                           <Step key={milestone.id}>
//                             <StepLabel StepIconProps={{ completed: milestone.status === 'completed' }}>
//                               <Box>
//                                 <Typography fontWeight={600}>{milestone.name}</Typography>
//                                 <Typography variant="caption" color="textSecondary">
//                                   Target: {milestone.targetDate} | Progress: {milestone.progress}%
//                                 </Typography>
//                                 <Box mt={1}>
//                                   <LinearProgress variant="determinate" value={milestone.progress} sx={{ height: 6, borderRadius: 3 }} />
//                                 </Box>
//                               </Box>
//                             </StepLabel>
//                           </Step>
//                         ))}
//                       </Stepper>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>
//             </Box>
//           )}
//         </Paper>

//         {/* Dialogs */}
//         <Dialog open={openContractorDialog} onClose={() => setOpenContractorDialog(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: 'bold' }}>➕ Add New Contractor</DialogTitle>
//           <DialogContent>
//             <TextField autoFocus margin="dense" label="Contractor Name" fullWidth value={newContractor.name} onChange={(e) => setNewContractor({ ...newContractor, name: e.target.value })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Contract Cost (₹ in Lakhs)" type="number" fullWidth value={newContractor.cost} onChange={(e) => setNewContractor({ ...newContractor, cost: e.target.value })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Completion Time (months)" type="number" fullWidth value={newContractor.time} onChange={(e) => setNewContractor({ ...newContractor, time: e.target.value })} />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenContractorDialog(false)}>Cancel</Button>
//             <Button onClick={handleAddContractor} variant="contained" color="primary">Add Contractor</Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog open={openEOTDialog} onClose={() => setOpenEOTDialog(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: 'bold' }}>⏰ Request EOT</DialogTitle>
//           <DialogContent>
//             <TextField select margin="dense" label="Contractor" fullWidth value={newEOT.contractor} onChange={(e) => setNewEOT({ ...newEOT, contractor: e.target.value })} sx={{ mb: 2 }}>
//               {contractors.map(c => <MenuItem key={c.id} value={c.name}>{c.name}</MenuItem>)}
//             </TextField>
//             <TextField margin="dense" label="Days Requested" type="number" fullWidth value={newEOT.requestedDays} onChange={(e) => setNewEOT({ ...newEOT, requestedDays: e.target.value })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Reason" multiline rows={3} fullWidth value={newEOT.reason} onChange={(e) => setNewEOT({ ...newEOT, reason: e.target.value })} />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenEOTDialog(false)}>Cancel</Button>
//             <Button onClick={handleAddEOT} variant="contained" color="primary">Submit to AE</Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog open={openCOSDialog} onClose={() => setOpenCOSDialog(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: 'bold' }}>💰 Request COS</DialogTitle>
//           <DialogContent>
//             <TextField select margin="dense" label="Contractor" fullWidth value={newCOS.contractor} onChange={(e) => setNewCOS({ ...newCOS, contractor: e.target.value })} sx={{ mb: 2 }}>
//               {contractors.map(c => <MenuItem key={c.id} value={c.name}>{c.name}</MenuItem>)}
//             </TextField>
//             <TextField margin="dense" label="Amount Requested (₹)" type="number" fullWidth value={newCOS.requestedAmount} onChange={(e) => setNewCOS({ ...newCOS, requestedAmount: e.target.value })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Description" multiline rows={3} fullWidth value={newCOS.description} onChange={(e) => setNewCOS({ ...newCOS, description: e.target.value })} />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenCOSDialog(false)}>Cancel</Button>
//             <Button onClick={handleAddCOS} variant="contained" color="primary">Submit to AE</Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog open={openBillingDialog} onClose={() => setOpenBillingDialog(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: 'bold' }}>💰 Raise Bill</DialogTitle>
//           <DialogContent>
//             <TextField select margin="dense" label="Contractor" fullWidth value={newBilling.contractor} onChange={(e) => setNewBilling({ ...newBilling, contractor: e.target.value })} sx={{ mb: 2 }}>
//               {contractors.map(c => <MenuItem key={c.id} value={c.name}>{c.name}</MenuItem>)}
//             </TextField>
//             <TextField margin="dense" label="Month" fullWidth placeholder="Dec 2024" value={newBilling.month} onChange={(e) => setNewBilling({ ...newBilling, month: e.target.value })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Amount Raised (₹)" type="number" fullWidth value={newBilling.raisedAmount} onChange={(e) => setNewBilling({ ...newBilling, raisedAmount: e.target.value })} />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenBillingDialog(false)}>Cancel</Button>
//             <Button onClick={handleAddBilling} variant="contained" color="primary">Submit to AE</Button>
//           </DialogActions>
//         </Dialog>

//         <Dialog open={openProgressDialog} onClose={() => setOpenProgressDialog(false)} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: 'bold' }}>📈 Update Site Progress</DialogTitle>
//           <DialogContent>
//             <Typography variant="body2" gutterBottom>Contractor: <strong>{selectedContractorForProgress?.contractor}</strong></Typography>
//             <TextField margin="dense" label="Physical Progress (%)" type="number" fullWidth value={selectedContractorForProgress?.physical || 0} onChange={(e) => setSelectedContractorForProgress({ ...selectedContractorForProgress, physical: parseInt(e.target.value) })} sx={{ mb: 2 }} />
//             <TextField margin="dense" label="Financial Progress (%)" type="number" fullWidth value={selectedContractorForProgress?.financial || 0} onChange={(e) => setSelectedContractorForProgress({ ...selectedContractorForProgress, financial: parseInt(e.target.value) })} />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenProgressDialog(false)}>Cancel</Button>
//             <Button onClick={handleUpdateProgress} variant="contained" color="primary">Update Progress</Button>
//           </DialogActions>
//         </Dialog>

//         {/* Snackbar */}
//         <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
//           <Alert severity={snackbar.severity} sx={{ borderRadius: 2, boxShadow: 3 }}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Box>
//     </ThemeProvider>
//   );
// };
// Add InfoIcon import



const AdminDashboardDetails = () => {

  const [today, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);


  const hour = today.getHours();
  const wish = `Good ${(hour < 12 && "Morning") || (hour < 17 && "Afternoon") || "Evening"
    } `;

  return (
    <div>
      <div className='workarea-background'>
        <Dashboardnavbar url="Dashboard" name={wish} />

        <div>
          <div>
            <StatsCards />
          </div>



          <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <ProjectStatusChart />
            <VacantListt />
            {/* <VacantPositionsDashboard /> */}
            {/* <VacantList /> */}
          </div>
          <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <EOTDashboard />
            <COSDashboard />
          </div>
          <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <Progress />
            <Milestone />

          </div>

          <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <BankGuarantee />
            <Insurance />
          </div>

          {/* <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <PNLDashboard />
            <InovoiceDashboard />
          </div> */}


          <div className='flex-row justify-evenly' style={{ margin: "0px 10px" }}>
            <ContractorBilling />
            <LetterTypeTable />
          </div>

          <div className='flex-row' style={{ margin: "0px 10px" }}>

            <LetterTatTable />
          </div>

          {/* <ProjectList /> */}
          {/* <ProjectListSubmitted /> */}
          {/* <LetterSummary/> */}

          {/* <LetterTypeTable /> */}
          {/* <LetterList />
          <ProjectLists /> */}

          {/* <VacantPositionsDashboard/> */}
        </div>

        {/* <div >
          <DashboardChart />
          <BillingStatisticsChart />


        </div> */}




      </div>

    </div>
  )
}

export default AdminDashboardDetails




// import React, { useState, useEffect } from 'react';
// import './adminprojectdashboard.css';

// import {
//   Chart as ChartJS,
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   PointElement,
//   LineElement,
//   Filler,
//   ScatterController,
//   DoughnutController,
//   LineController,
//   BarController,
// } from 'chart.js';
// import { Chart } from 'react-chartjs-2';

// // Register ChartJS components
// ChartJS.register(
//   BarElement,
//   CategoryScale,
//   LinearScale,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   PointElement,
//   LineElement,
//   Filler,
//   ScatterController,
//   DoughnutController,
//   LineController,
//   BarController
// );

// // Helper functions
// const rnd = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;
// const cr = (v) => '₹' + (v / 100).toFixed(1) + 'Cr';
// const lk = (v) => '₹' + Math.round(v) + 'L';

// const PNAMES = ["NHAI Highway Ph-1", "NHAI Highway Ph-2", "Metro Corridor East", "Metro Corridor West", "RVNL Bridge Works", "RVNL Station Bldg", "Smart City Pkg-A", "Smart City Pkg-B", "Expressway Tunnel", "Rail Overbridge", "Industrial Zone Rd", "Port Connectivity", "Water Treatment Ph1", "Water Treatment Ph2", "SEZ Infrastructure", "Airport Link Rd", "Flyover Complex", "Urban Drainage", "Coastal Highway", "Hill Road Widening", "Township Infra A", "Township Infra B", "Solar Plant Civil", "Wind Farm Access", "River Embankment", "Reservoir Dam Pkg", "Irrigation Canal A", "Irrigation Canal B", "Substation Civil", "Transmission Line", "NH-48 Package", "SH-7 Works", "City Bypass Rd", "Freight Corridor", "Cold Storage Infra", "Logistic Park Civil", "Waste Mgmt Plant", "River Bridge Pkg", "Tunnel Section A", "Tunnel Section B"];
// const STATS = ["On Track", "Delayed", "Completed", "On Track", "On Track", "Delayed"];
// const MN = ["Foundation", "Superstructure", "Finishing", "Handover", "Testing", "Commissioning", "Survey", "Design Approval"];

// const generateProjects = () => {
//   let PROJECTS = [];
//   let cid = 1;
//   PNAMES.forEach((pname, pi) => {
//     const nc = pi < 30 ? 2 : 1;
//     const contractors = [];
//     for (let c = 0; c < nc; c++) {
//       const ca = rnd(200, 2000);
//       const nb = rnd(2, 5);
//       const bills = [];
//       let tR = 0, tA = 0, tCl = 0, pend = 0;
//       for (let b = 0; b < nb; b++) {
//         const raised = rnd(20, 150), ae = rnd(Math.floor(raised * .65), raised), cl = rnd(Math.floor(ae * .75), ae);
//         const st = b < nb - 1 ? 'Approved' : rnd(0, 1) ? 'Pending' : 'Approved';
//         if (st === 'Pending') pend++;
//         tR += raised; tA += ae; tCl += cl;
//         bills.push({ month: 'M' + (b + 1), raised, ae, cl, status: st });
//       }
//       const ne = rnd(2, 6); const eots = []; let eotDA = 0;
//       for (let e = 0; e < ne; e++) {
//         const rd = rnd(10, 90), ar = rnd(5, rd), ca2 = rnd(0, 1) ? rnd(0, ar) : null;
//         if (ca2) eotDA += ca2;
//         eots.push({ rd, ar, ca: ca2, status: ca2 === null ? 'Rejected' : ca2 > 0 ? 'Approved' : 'Pending' });
//       }
//       const no = rnd(1, 5); const coss = []; let cosA = 0;
//       for (let o = 0; o < no; o++) {
//         const ra = rnd(10, 200), ar2 = rnd(Math.floor(ra * .5), ra), ca3 = rnd(0, 1) ? rnd(0, ar2) : null;
//         if (ca3) cosA += ca3;
//         coss.push({ ra, ar: ar2, ca: ca3, status: ca3 === null ? 'Rejected' : ca3 > 0 ? 'Approved' : 'Pending' });
//       }
//       const nm = rnd(1, 4); const ms = [];
//       for (let m = 0; m < nm; m++) ms.push({ name: MN[m % MN.length], status: rnd(0, 1) ? 'Completed' : 'In Progress' });
//       const phys = rnd(20, 100), fin = Math.min(phys, rnd(10, phys));
//       contractors.push({
//         id: 'C' + String(cid).padStart(3, '0'), name: 'Contractor ' + cid, ca, tR, tA, tCl, pend, bills, eots, coss, ms, phys, fin, eotDA, cosA,
//         status: STATS[rnd(0, STATS.length - 1)]
//       });
//       cid++;
//     }
//     const pA = contractors.reduce((s, c) => s + c.tCl, 0);
//     const pP = contractors.reduce((s, c) => s + c.pend * rnd(20, 80), 0);
//     const pC = contractors.reduce((s, c) => s + c.ca, 0);
//     PROJECTS.push({
//       id: 'P' + String(pi + 1).padStart(2, '0'), name: pname, contractors, pA, pP, pC,
//       totalEOTs: contractors.reduce((s, c) => s + c.eots.length, 0),
//       eotApp: contractors.reduce((s, c) => s + c.eots.filter(e => e.status === 'Approved').length, 0),
//       eotPend: contractors.reduce((s, c) => s + c.eots.filter(e => e.status === 'Pending').length, 0),
//       eotRej: contractors.reduce((s, c) => s + c.eots.filter(e => e.status === 'Rejected').length, 0),
//       totalCOS: contractors.reduce((s, c) => s + c.coss.length, 0),
//       cosApp: contractors.reduce((s, c) => s + c.coss.filter(o => o.status === 'Approved').length, 0),
//       cosPend: contractors.reduce((s, c) => s + c.coss.filter(o => o.status === 'Pending').length, 0),
//       cosRej: contractors.reduce((s, c) => s + c.coss.filter(o => o.status === 'Rejected').length, 0),
//       totalMS: contractors.reduce((s, c) => s + c.ms.length, 0),
//       msD: contractors.reduce((s, c) => s + c.ms.filter(m => m.status === 'Completed').length, 0),
//       avgP: Math.round(contractors.reduce((s, c) => s + c.phys, 0) / contractors.length),
//       avgF: Math.round(contractors.reduce((s, c) => s + c.fin, 0) / contractors.length),
//       status: STATS[pi % STATS.length]
//     });
//   });
//   return PROJECTS;
// };

// const AdminDashboardDetails = () => {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [filters, setFilters] = useState({ project: '', status: '', sort: 'contract' });
//   const [activeTab, setActiveTab] = useState('overview');
//   const [drillProject, setDrillProject] = useState('');

//   useEffect(() => {
//     const proj = generateProjects();
//     setProjects(proj);
//     setFilteredProjects(proj);
//     if (proj.length) setDrillProject(proj[0].id);
//   }, []);

//   useEffect(() => {
//     applyFilter();
//   }, [filters, projects]);

//   const applyFilter = () => {
//     let fp = projects.filter(p => (!filters.project || p.id === filters.project) && (!filters.status || p.status === filters.status));
//     if (filters.sort === 'billing') fp.sort((a, b) => (b.pA / b.pC) - (a.pA / a.pC));
//     else if (filters.sort === 'progress') fp.sort((a, b) => b.avgP - a.avgP);
//     else if (filters.sort === 'eot') fp.sort((a, b) => b.totalEOTs - a.totalEOTs);
//     else fp.sort((a, b) => b.pC - a.pC);
//     setFilteredProjects(fp);
//   };

//   const TabButton = ({ id, label, icon }) => (
//     <button className={`tab ${activeTab === id ? 'on' : ''}`} onClick={() => setActiveTab(id)}>
//       <i className={`ti ti-${icon}`} aria-hidden="true"></i> {label}
//     </button>
//   );

//   return (
//     <div className="app-container">
//       <div className="page">
//         <div className="header">
//           <div className="header-left">
//             <div className="logo-box"><i className="ti ti-building-factory-2" aria-hidden="true"></i></div>
//             <div>
//               <div className="header-title">Site tracking</div>
//               <div className="header-sub">{projects.length} projects · {projects.flatMap(p => p.contractors).length} contractors · Live data</div>
//             </div>
//           </div>
//           <div className="header-controls">
//             <select className="ctrl-select" value={filters.project} onChange={e => setFilters({ ...filters, project: e.target.value })}>
//               <option value="">All projects</option>
//               {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </select>
//             <select className="ctrl-select" value={filters.status} onChange={e => setFilters({ ...filters, status: e.target.value })}>
//               <option value="">All statuses</option>
//               <option>On Track</option><option>Delayed</option><option>Completed</option>
//             </select>
//             <select className="ctrl-select" value={filters.sort} onChange={e => setFilters({ ...filters, sort: e.target.value })}>
//               <option value="contract">By contract value</option>
//               <option value="billing">By billing %</option>
//               <option value="progress">By progress</option>
//               <option value="eot">By EOTs</option>
//             </select>
//           </div>
//         </div>

//         <KpiRow projects={filteredProjects} />

//         <div className="tab-bar">
//           <TabButton id="overview" label="Overview" icon="layout-dashboard" />
//           <TabButton id="billing" label="Billing" icon="file-invoice" />
//           <TabButton id="eot" label="EOT & COS" icon="clock-edit" />
//           <TabButton id="progress" label="Progress" icon="trending-up" />
//           <TabButton id="alerts" label="Alerts" icon="alert-triangle" />
//           <TabButton id="drill" label="Drill-down" icon="zoom-in" />
//         </div>

//         {activeTab === 'overview' && <OverviewPanel projects={filteredProjects} />}
//         {activeTab === 'billing' && <BillingPanel projects={filteredProjects} />}
//         {activeTab === 'eot' && <EotPanel projects={filteredProjects} />}
//         {activeTab === 'progress' && <ProgressPanel projects={filteredProjects} />}
//         {activeTab === 'alerts' && <AlertsPanel projects={filteredProjects} />}
//         {activeTab === 'drill' && <DrillPanel projects={projects} drillProject={drillProject} setDrillProject={setDrillProject} />}
//       </div>
//     </div>
//   );
// };

// // KPI Row Component
// const KpiRow = ({ projects }) => {
//   const tB = projects.reduce((s, p) => s + p.pA, 0);
//   const tC = projects.reduce((s, p) => s + p.pC, 0);
//   const tE = projects.reduce((s, p) => s + p.totalEOTs, 0);
//   const eA = projects.reduce((s, p) => s + p.eotApp, 0);
//   const tCO = projects.reduce((s, p) => s + p.totalCOS, 0);
//   const cA = projects.reduce((s, p) => s + p.cosApp, 0);
//   const tM = projects.reduce((s, p) => s + p.totalMS, 0);
//   const mD = projects.reduce((s, p) => s + p.msD, 0);
//   const cts = projects.flatMap(p => p.contractors);
//   const aP = Math.round(cts.reduce((s, c) => s + c.phys, 0) / Math.max(cts.length, 1));
//   const delayed = projects.filter(p => p.status === 'Delayed').length;

//   const defs = [
//     { icon: 'building-skyscraper', color: '#378ADD', bg: '#E6F1FB', val: projects.length, label: 'Projects', sub: delayed + ' delayed', subBg: '#FCEBEB', subCol: '#A32D2D' },
//     { icon: 'currency-rupee', color: '#1D9E75', bg: '#E1F5EE', val: cr(tC), label: 'Contract value', sub: 'total', subBg: '#EAF3DE', subCol: '#3B6D11' },
//     { icon: 'file-check', color: '#7F77DD', bg: '#EEEDFE', val: cr(tB), label: 'Billing approved', sub: Math.round(tB / tC * 100) + '% of contract', subBg: '#EEEDFE', subCol: '#534AB7' },
//     { icon: 'calendar-check', color: '#EF9F27', bg: '#FAEEDA', val: eA + '/' + tE, label: 'EOT approved', sub: Math.round(eA / Math.max(tE, 1) * 100) + '% rate', subBg: '#FAEEDA', subCol: '#854F0B' },
//     { icon: 'receipt', color: '#D85A30', bg: '#FAECE7', val: cA + '/' + tCO, label: 'COS approved', sub: Math.round(cA / Math.max(tCO, 1) * 100) + '% rate', subBg: '#FAECE7', subCol: '#993C1D' },
//     { icon: 'trending-up', color: '#1D9E75', bg: '#E1F5EE', val: aP + '%', label: 'Avg progress', sub: 'physical', subBg: '#EAF3DE', subCol: '#3B6D11' },
//     { icon: 'flag-check', color: '#534AB7', bg: '#EEEDFE', val: mD + '/' + tM, label: 'Milestones', sub: Math.round(mD / Math.max(tM, 1) * 100) + '% done', subBg: '#EEEDFE', subCol: '#534AB7' },
//   ];

//   return (
//     <div className="krow">
//       {defs.map((d, i) => (
//         <div className="kcard" key={i}>
//           <div className="kcard-accent" style={{ background: d.color }}></div>
//           <div className="kcard-icon" style={{ color: d.color }}><i className={`ti ti-${d.icon}`} aria-hidden="true"></i></div>
//           <div className="kcard-val">{d.val}</div>
//           <div className="kcard-label">{d.label}</div>
//           <span className="kcard-sub" style={{ background: d.subBg, color: d.subCol }}>{d.sub}</span>
//         </div>
//       ))}
//     </div>
//   );
// };

// // Overview Panel (Fully working)
// const OverviewPanel = ({ projects }) => {
//   const top10 = projects.slice(0, 10);
//   const labels = top10.map(p => p.name.slice(0, 13));
//   const barData = {
//     labels,
//     datasets: [
//       { label: 'Approved', data: top10.map(p => +(p.pA / 100).toFixed(1)), backgroundColor: '#378ADD', borderRadius: 3, stack: 's' },
//       { label: 'Pending', data: top10.map(p => +(p.pP / 100).toFixed(1)), backgroundColor: '#D4537E', borderRadius: 3, stack: 's' },
//       { label: 'Remaining', data: top10.map(p => +Math.max(0, (p.pC - p.pA - p.pP) / 100).toFixed(1)), backgroundColor: '#E2E0D8', borderRadius: 3, stack: 's' }
//     ]
//   };

//   const statusCount = projects.reduce((a, p) => { a[p.status] = (a[p.status] || 0) + 1; return a; }, {});
//   const statusLabels = Object.keys(statusCount);
//   const statusColors = { 'On Track': '#1D9E75', 'Delayed': '#E24B4A', 'Completed': '#378ADD' };
//   const doughnutData = { labels: statusLabels, datasets: [{ data: Object.values(statusCount), backgroundColor: statusLabels.map(l => statusColors[l] || '#888'), borderWidth: 0 }] };

//   const contractors = projects.flatMap(p => p.contractors);
//   const scatterData = {
//     datasets: [
//       { label: 'On Track', data: contractors.filter(c => c.status === 'On Track').map(c => ({ x: c.phys, y: c.fin })), backgroundColor: '#1D9E75', pointRadius: 4 },
//       { label: 'Delayed', data: contractors.filter(c => c.status === 'Delayed').map(c => ({ x: c.phys, y: c.fin })), backgroundColor: '#E24B4A', pointRadius: 4, pointStyle: 'triangle' },
//       { label: 'Completed', data: contractors.filter(c => c.status === 'Completed').map(c => ({ x: c.phys, y: c.fin })), backgroundColor: '#378ADD', pointRadius: 4, pointStyle: 'rect' }
//     ]
//   };

//   const bkts = [0, 0, 0, 0, 0];
//   contractors.forEach(c => { bkts[c.ca < 400 ? 0 : c.ca < 800 ? 1 : c.ca < 1200 ? 2 : c.ca < 1600 ? 3 : 4]++; });
//   const histData = { labels: ['<400L', '400–800', '800–1200', '1200–1600', '>1600'], datasets: [{ data: bkts, backgroundColor: '#378ADD', borderRadius: 4 }] };

//   const ms8 = projects.slice(0, 8);
//   const msData = {
//     labels: ms8.map(p => p.name.slice(0, 10)),
//     datasets: [
//       { label: 'Done', data: ms8.map(p => p.msD), backgroundColor: '#1D9E75', borderRadius: 3, stack: 'm' },
//       { label: 'Pending', data: ms8.map(p => p.totalMS - p.msD), backgroundColor: '#D3D1C7', borderRadius: 3, stack: 'm' }
//     ]
//   };

//   return (
//     <div>
//       <div className="g2" style={{ alignItems: "center" }}>
//         <div className="card">
//           <div className="card-hd"><span className="card-title"><i className="ti ti-chart-bar"></i> Billing pipeline</span></div>
//           <div className="leg"><span className="leg-item"><span className="leg-dot" style={{ background: '#378ADD' }}></span>Approved</span><span className="leg-item"><span className="leg-dot" style={{ background: '#D4537E' }}></span>Pending</span><span className="leg-item"><span className="leg-dot" style={{ background: '#E2E0D8' }}></span>Remaining</span></div>
//           <div style={{ height: '220px', width: "100%" }}><Chart type="bar" data={barData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { stacked: true }, y: { stacked: true, ticks: { callback: v => v + 'Cr' } } } }} /></div>
//         </div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-flag"></i> Milestone completion</span></div><div style={{ height: '200px', width: "100%" }}><Chart type="bar" data={msData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { stacked: true }, y: { stacked: true } } }} /></div></div>


//       </div>
//       <div className="g3">
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-point"></i> Phys vs financial scatter</span></div><div style={{ height: '170px' }}><Chart type="scatter" data={scatterData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { title: { display: true, text: 'Physical %' } }, y: { title: { display: true, text: 'Financial %' } } } }} /></div></div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-chart-histogram"></i> Contract size distribution</span></div><div style={{ height: '170px' }}><Chart type="bar" data={histData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } } }} /></div></div>
//         <div className="card">
//           <div className="card-hd"><span className="card-title"><i className="ti ti-chart-donut"></i> Project status split</span></div>
//           <div style={{ marginBottom: '20px' }}><div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>{statusLabels.map((l) => <span key={l} className="leg-item"><span className="leg-dot" style={{ background: statusColors[l] }}></span>{l}: <strong>{statusCount[l]}</strong></span>)}</div></div>
//           <div style={{ height: '150px', width: "100%" }}><Chart type="doughnut" data={doughnutData} options={{ responsive: true, maintainAspectRatio: false, cutout: '68%', plugins: { legend: { display: false } } }} /></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Billing Panel - FULL WORKING
// const BillingPanel = ({ projects }) => {
//   const months = ['M1', 'M2', 'M3', 'M4', 'M5'];
//   const mR = months.map((_, i) => +(projects.flatMap(p => p.contractors).flatMap(c => c.bills).filter(b => b.month === 'M' + (i + 1)).reduce((s, b) => s + b.raised, 0) / 100).toFixed(1));
//   const mA = months.map((_, i) => +(projects.flatMap(p => p.contractors).flatMap(c => c.bills).filter(b => b.month === 'M' + (i + 1)).reduce((s, b) => s + b.ae, 0) / 100).toFixed(1));
//   const mC = months.map((_, i) => +(projects.flatMap(p => p.contractors).flatMap(c => c.bills).filter(b => b.month === 'M' + (i + 1)).reduce((s, b) => s + b.cl, 0) / 100).toFixed(1));

//   const top8 = projects.slice(0, 8);
//   const haircutData = {
//     labels: top8.map(p => p.name.slice(0, 11)),
//     datasets: [
//       { label: 'AE cut %', data: top8.map(p => { const r = p.contractors.reduce((s, c) => s + c.tR, 0), a = p.contractors.reduce((s, c) => s + c.tA, 0); return r ? Math.round((1 - a / r) * 100) : 0; }), backgroundColor: '#EF9F27', borderRadius: 3 },
//       { label: 'Client cut %', data: top8.map(p => { const a = p.contractors.reduce((s, c) => s + c.tA, 0); return a ? Math.round((1 - p.pA / a) * 100) : 0; }), backgroundColor: '#D85A30', borderRadius: 3 }
//     ]
//   };

//   return (
//     <div>
//       <div className="g2">
//         <div className="card">
//           <div className="card-hd"><span className="card-title"><i className="ti ti-chart-line"></i> Monthly billing trend (₹Cr)</span></div>
//           <div className="leg"><span className="leg-item"><span className="leg-dot" style={{ background: '#85B7EB' }}></span>Raised</span><span className="leg-item"><span className="leg-dot" style={{ background: '#378ADD' }}></span>AE approved</span><span className="leg-item"><span className="leg-dot" style={{ background: '#D4537E' }}></span>Client approved</span></div>
//           <div style={{ height: '200px' }}><Chart type="line" data={{ labels: months, datasets: [{ label: 'Raised', data: mR, borderColor: '#85B7EB', backgroundColor: 'rgba(133,183,235,.1)', fill: true, tension: 0.3 }, { label: 'AE', data: mA, borderColor: '#378ADD', borderDash: [5, 3], tension: 0.3 }, { label: 'Client', data: mC, borderColor: '#D4537E', backgroundColor: 'rgba(212,83,126,.06)', fill: true, tension: 0.3 }] }} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { ticks: { callback: v => v + 'Cr' } } } }} /></div>
//         </div>
//         <div className="card">
//           <div className="card-hd"><span className="card-title"><i className="ti ti-scissors"></i> AE & client cut %</span></div>
//           <div style={{ height: '200px' }}><Chart type="bar" data={haircutData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { ticks: { callback: v => v + '%' } } } }} /></div>
//         </div>
//       </div>
//       <div className="g1 card">
//         <div className="card-hd"><span className="card-title"><i className="ti ti-table"></i> Contractor billing detail</span></div>
//         <div className="scroll-x">
//           <table>
//             <thead><tr><th>Project</th><th>Contractor</th><th>Bills</th><th>Raised</th><th>AE approved</th><th>Client approved</th><th>AE cut</th><th>Client cut</th><th>Pending</th></tr></thead>
//             <tbody>
//               {projects.flatMap(p => p.contractors.map(c => {
//                 const aeC = c.tR ? Math.round((1 - c.tA / c.tR) * 100) : 0, clC = c.tA ? Math.round((1 - c.tCl / c.tA) * 100) : 0;
//                 return <tr key={c.id}><td style={{ fontSize: '11px', color: 'var(--color-text-secondary)' }}>{p.name.slice(0, 15)}</td><td>{c.name}</td><td style={{ textAlign: 'center' }}>{c.bills.length}</td><td className="r">{lk(c.tR)}</td><td className="r">{lk(c.tA)}</td><td className="r">{lk(c.tCl)}</td><td style={{ textAlign: 'center' }}><span className={`badge ${aeC > 30 ? 'delayed' : 'pending'}`}>{aeC}%</span></td><td style={{ textAlign: 'center' }}><span className={`badge ${clC > 30 ? 'delayed' : 'pending'}`}>{clC}%</span></td><td style={{ textAlign: 'center' }}><span className="badge pending">{c.pend}</span></td></tr>;
//               }))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // EOT Panel - FULL WORKING
// const EotPanel = ({ projects }) => {
//   const top8 = projects.slice(0, 8);
//   const labels = top8.map(p => p.name.slice(0, 11));

//   return (
//     <div>
//       <div className="g2">
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-calendar-plus"></i> EOT days comparison</span></div><div style={{ height: '200px' }}><Chart type="bar" data={{ labels, datasets: [{ label: 'Requested', data: top8.map(p => p.contractors.reduce((s, c) => s + c.eots.reduce((a, e) => a + e.rd, 0), 0)), backgroundColor: '#AFA9EC' }, { label: 'AE rec', data: top8.map(p => p.contractors.reduce((s, c) => s + c.eots.reduce((a, e) => a + e.ar, 0), 0)), backgroundColor: '#7F77DD' }, { label: 'Client app', data: top8.map(p => p.contractors.reduce((s, c) => s + c.eotDA, 0)), backgroundColor: '#534AB7' }] }} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { ticks: { callback: v => v + 'd' } } } }} /></div></div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-currency-rupee"></i> COS amount comparison (₹L)</span></div><div style={{ height: '200px' }}><Chart type="bar" data={{ labels, datasets: [{ label: 'Requested', data: top8.map(p => p.contractors.reduce((s, c) => s + c.coss.reduce((a, o) => a + o.ra, 0), 0)), backgroundColor: '#F0997B' }, { label: 'AE rec', data: top8.map(p => p.contractors.reduce((s, c) => s + c.coss.reduce((a, o) => a + o.ar, 0), 0)), backgroundColor: '#D85A30' }, { label: 'Client app', data: top8.map(p => p.contractors.reduce((s, c) => s + c.cosA, 0)), backgroundColor: '#993C1D' }] }} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { ticks: { callback: v => v + 'L' } } } }} /></div></div>
//       </div>
//       <div className="g1 card">
//         <div className="card-hd"><span className="card-title"><i className="ti ti-table"></i> EOT & COS contractor detail</span></div>
//         <div className="scroll-x">
//           <table>
//             <thead><tr><th>Project</th><th>Contractor</th><th>EOTs</th><th>EOT approved</th><th>Days approved</th><th>COS</th><th>COS approved</th><th>COS amt</th></tr></thead>
//             <tbody>
//               {projects.flatMap(p => p.contractors.map(c => {
//                 const eA = c.eots.filter(e => e.status === 'Approved').length, cA = c.coss.filter(o => o.status === 'Approved').length;
//                 return <tr key={c.id}><td style={{ fontSize: '11px', color: 'var(--color-text-secondary)' }}>{p.name.slice(0, 14)}</td><td>{c.name}</td><td style={{ textAlign: 'center' }}>{c.eots.length}</td><td style={{ textAlign: 'center' }}><span className={`badge ${eA === c.eots.length ? 'approved' : 'pending'}`}>{eA}</span></td><td style={{ textAlign: 'center', fontWeight: '500' }}>{c.eotDA}d</td><td style={{ textAlign: 'center' }}>{c.coss.length}</td><td style={{ textAlign: 'center' }}><span className={`badge ${cA === c.coss.length ? 'approved' : 'pending'}`}>{cA}</span></td><td className="r">{lk(c.cosA)}</td></tr>;
//               }))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Progress Panel - FULL WORKING
// const ProgressPanel = ({ projects }) => {
//   const top12 = projects.slice(0, 12);
//   const gapData = { labels: top12.map(p => p.name.slice(0, 10)), datasets: [{ label: 'Physical %', data: top12.map(p => p.avgP), backgroundColor: '#1D9E75' }, { label: 'Financial %', data: top12.map(p => p.avgF), backgroundColor: '#378ADD' }] };

//   return (
//     <div>
//       <div className="g2">
//         <div className="card">
//           <div className="card-hd"><span className="card-title"><i className="ti ti-layout-grid"></i> Physical progress heatmap</span></div>
//           <div className="heat-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '8px' }}>
//             {projects.slice(0, 20).map(p => {
//               const v = p.avgP, r = Math.round(220 - v * 1.8), g = Math.round(60 + v * 1.4);
//               return <div key={p.id} className="hcell" style={{ background: `rgb(${r}, ${Math.min(g, 185)}, 40)`, color: v > 55 ? '#173404' : '#639922', padding: '6px', textAlign: 'center', borderRadius: '6px' }}>{v}%</div>;
//             })}
//           </div>
//         </div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-arrows-diff"></i> Physical vs financial gap</span></div><div style={{ height: '200px' }}><Chart type="bar" data={gapData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'bottom' } }, scales: { y: { max: 115, ticks: { callback: v => v + '%' } } } }} /></div></div>
//       </div>
//       <div className="g1 card">
//         <div className="card-hd"><span className="card-title"><i className="ti ti-flag-check"></i> Milestone tracker</span></div>
//         <div className="scroll-x">
//           <table>
//             <thead><tr><th>Project</th><th>Contractor</th><th>Total</th><th>Done</th><th>In progress</th><th>Completion</th></tr></thead>
//             <tbody>
//               {projects.flatMap(p => p.contractors.map(c => {
//                 const d = c.ms.filter(m => m.status === 'Completed').length, inp = c.ms.length - d, pct = Math.round(d / Math.max(c.ms.length, 1) * 100);
//                 return <tr key={c.id}><td style={{ fontSize: '11px' }}>{p.name.slice(0, 14)}</td><td>{c.name}</td><td style={{ textAlign: 'center' }}>{c.ms.length}</td><td style={{ textAlign: 'center' }}><span className="badge approved">{d}</span></td><td style={{ textAlign: 'center' }}><span className="badge pending">{inp}</span></td><td><div className="pb-wrap"><div className="pb"><div className="pf" style={{ width: `${pct}%`, background: '#1D9E75' }}></div></div><span className="pct-txt">{pct}%</span></div></td></tr>;
//               }))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Alerts Panel - FULL WORKING
// const AlertsPanel = ({ projects }) => {
//   const contractors = projects.flatMap(p => p.contractors.map(c => ({ ...c, projectName: p.name })));
//   const scatterData = {
//     datasets: [
//       { label: 'On Track', data: contractors.filter(c => c.status === 'On Track').map(c => ({ x: Math.round(c.tCl / c.ca * 100), y: c.phys })), backgroundColor: '#1D9E75', pointRadius: 5 },
//       { label: 'Delayed', data: contractors.filter(c => c.status === 'Delayed').map(c => ({ x: Math.round(c.tCl / c.ca * 100), y: c.phys })), backgroundColor: '#E24B4A', pointRadius: 5, pointStyle: 'triangle' },
//       { label: 'Completed', data: contractors.filter(c => c.status === 'Completed').map(c => ({ x: Math.round(c.tCl / c.ca * 100), y: c.phys })), backgroundColor: '#378ADD', pointRadius: 5, pointStyle: 'rect' }
//     ]
//   };

//   const alerts = [];
//   projects.forEach(p => {
//     p.contractors.forEach(c => {
//       const bPct = Math.round(c.tCl / c.ca * 100);
//       if (c.status === 'Delayed') alerts.push({ sev: 'danger', icon: 'alert-triangle', title: `${c.name} — ${p.name.slice(0, 16)}`, sub: `Delayed · Physical: ${c.phys}% · Billing: ${bPct}%` });
//       if (bPct > 80 && c.phys < 50) alerts.push({ sev: 'warning', icon: 'alert-circle', title: `Billing-progress mismatch`, sub: `${c.name}: ${bPct}% billed but only ${c.phys}% physical` });
//       if (c.eots.filter(e => e.status === 'Pending').length > 1) alerts.push({ sev: 'info', icon: 'clock-edit', title: `Pending EOTs — ${c.name}`, sub: `${c.eots.filter(e => e.status === 'Pending').length} EOTs awaiting response` });
//     });
//   });

//   const cfg = { danger: { bg: '#FCEBEB', border: '#F09595', icBg: '#FCEBEB', icCol: '#A32D2D' }, warning: { bg: '#FAEEDA', border: '#FAC775', icBg: '#FAEEDA', icCol: '#854F0B' }, info: { bg: '#E6F1FB', border: '#B5D4F4', icBg: '#E6F1FB', icCol: '#185FA5' } };

//   return (
//     <div>
//       <div className="g2">
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-chart-scatter"></i> Risk matrix — billing% vs progress%</span></div><div style={{ height: '220px' }}><Chart type="scatter" data={scatterData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { title: { display: true, text: 'Billing %' }, min: 0, max: 120 }, y: { title: { display: true, text: 'Physical %' }, min: 0, max: 120 } } }} /></div></div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-bell-ringing"></i> Active alerts</span></div><div style={{ maxHeight: '260px', overflowY: 'auto' }}>{alerts.slice(0, 8).map((a, i) => { const c = cfg[a.sev]; return <div key={i} className="alert-item" style={{ background: c.bg, borderColor: c.border }}><div className="alert-icon-wrap" style={{ background: c.icBg, color: c.icCol }}><i className={`ti ti-${a.icon}`}></i></div><div className="alert-body"><div className="alert-title" style={{ color: c.icCol }}>{a.title}</div><div className="alert-sub">{a.sub}</div></div></div>; })}</div></div>
//       </div>
//       <div className="g1 card">
//         <div className="card-hd"><span className="card-title"><i className="ti ti-table"></i> Contractor risk table</span></div>
//         <div className="scroll-x">
//           <table>
//             <thead><tr><th>Contractor</th><th>Project</th><th>Status</th><th>Billing%</th><th>Phys%</th><th>Fin%</th><th>Pending EOTs</th><th>Pending COS</th><th>Risk</th></tr></thead>
//             <tbody>
//               {projects.flatMap(p => p.contractors.map(c => {
//                 const bPct = Math.round(c.tCl / c.ca * 100), pe = c.eots.filter(e => e.status === 'Pending').length, pco = c.coss.filter(o => o.status === 'Pending').length;
//                 let r = 0; if (c.status === 'Delayed') r += 3; if (bPct > 80 && c.phys < 60) r += 2; if (pe > 1) r += 1; if (pco > 1) r += 1;
//                 const rl = r >= 4 ? 'High' : r >= 2 ? 'Medium' : 'Low';
//                 return <tr key={c.id}><td>{c.name}</td><td style={{ fontSize: '11px' }}>{p.name.slice(0, 14)}</td><td><span className={`badge ${c.status === 'Delayed' ? 'delayed' : c.status === 'Completed' ? 'completed' : 'on-track'}`}>{c.status}</span></td><td style={{ textAlign: 'center' }}>{bPct}%</td><td style={{ textAlign: 'center' }}>{c.phys}%</td><td style={{ textAlign: 'center' }}>{c.fin}%</td><td style={{ textAlign: 'center' }}>{pe}</td><td style={{ textAlign: 'center' }}>{pco}</td><td><span className={`badge ${rl === 'High' ? 'high' : rl === 'Medium' ? 'med' : 'low'}`}>{rl}</span></td></tr>;
//               }))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Drill Panel - FULL WORKING
// const DrillPanel = ({ projects, drillProject, setDrillProject }) => {
//   const selected = projects.find(p => p.id === drillProject) || projects[0];
//   if (!selected) return null;

//   const doughnutData = { labels: selected.contractors.map(c => c.name.slice(0, 14)), datasets: [{ data: selected.contractors.map(c => Math.round(c.tCl)), backgroundColor: ['#378ADD', '#1D9E75', '#EF9F27', '#D4537E', '#7F77DD', '#D85A30'], borderWidth: 0 }] };
//   const barData = { labels: selected.contractors.map(c => c.name.slice(0, 12)), datasets: [{ label: 'EOT days', data: selected.contractors.map(c => c.eotDA), backgroundColor: '#534AB7' }, { label: 'COS amt (₹L)', data: selected.contractors.map(c => Math.round(c.cosA)), backgroundColor: '#D85A30' }] };

//   return (
//     <div>
//       <div className="section-label">Select project</div>
//       <select className="dd-proj-select" value={drillProject} onChange={e => setDrillProject(e.target.value)}>
//         {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
//       </select>
//       <div className="krow" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr))' }}>
//         <div className="kcard"><div className="kcard-val">{cr(selected.pC)}</div><div className="kcard-label">Contract value</div></div>
//         <div className="kcard"><div className="kcard-val">{cr(selected.pA)}</div><div className="kcard-label">Approved billing</div></div>
//         <div className="kcard"><div className="kcard-val">{selected.avgP}%</div><div className="kcard-label">Avg progress</div></div>
//         <div className="kcard"><div className="kcard-val">{selected.msD}/{selected.totalMS}</div><div className="kcard-label">Milestones</div></div>
//       </div>
//       <div className="g2">
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-chart-donut"></i> Contractor billing share</span></div><div style={{ height: '200px' }}><Chart type="doughnut" data={doughnutData} options={{ responsive: true, maintainAspectRatio: false, cutout: '60%', plugins: { legend: { position: 'bottom', labels: { font: { size: 10 } } } } }} /></div></div>
//         <div className="card"><div className="card-hd"><span className="card-title"><i className="ti ti-chart-bar"></i> EOT days & COS amount</span></div><div style={{ height: '200px' }}><Chart type="bar" data={barData} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'bottom' } } }} /></div></div>
//       </div>
//       <div className="g1 card">
//         <div className="card-hd"><span className="card-title"><i className="ti ti-table"></i> Contractor full detail</span></div>
//         <div className="scroll-x">
//           <table>
//             <thead><tr><th>Contractor</th><th>Contract</th><th>Approved</th><th>Billing%</th><th>EOTs</th><th>EOT days</th><th>COS</th><th>COS amt</th><th>Phys%</th><th>Fin%</th><th>Milestones</th><th>Status</th></tr></thead>
//             <tbody>
//               {selected.contractors.map(c => {
//                 const bPct = Math.round(c.tCl / c.ca * 100), msD = c.ms.filter(m => m.status === 'Completed').length;
//                 return <tr key={c.id}><td style={{ fontWeight: '500' }}>{c.name}</td><td className="r">{lk(c.ca)}</td><td className="r">{lk(c.tCl)}</td><td><div className="pb-wrap"><div className="pb"><div className="pf" style={{ width: `${bPct}%`, background: '#378ADD' }}></div></div><span className="pct-txt">{bPct}%</span></div></td><td style={{ textAlign: 'center' }}>{c.eots.length}</td><td style={{ textAlign: 'center' }}>{c.eotDA}d</td><td style={{ textAlign: 'center' }}>{c.coss.length}</td><td className="r">{lk(c.cosA)}</td><td style={{ textAlign: 'center' }}>{c.phys}%</td><td style={{ textAlign: 'center' }}>{c.fin}%</td><td style={{ textAlign: 'center' }}>{msD}/{c.ms.length}</td><td><span className={`badge ${c.status === 'Delayed' ? 'delayed' : c.status === 'Completed' ? 'completed' : 'on-track'}`}>{c.status}</span></td></tr>;
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboardDetails;